if(window.BSS_BCP_V2.r4q.logics.length) {
    BSS_BCP_V2.customData = {}
    const COUNTRY_NAME_JP = {
        AF: "アフガニスタン",
        AX: "オーランド諸島",
        AL: "アルバニア",
        DZ: "アルジェリア",
        AD: "アンドラ",
        AO: "アンゴラ",
        AI: "アンギラ",
        AG: "アンティグア・バーブーダ",
        AR: "アルゼンチン",
        AM: "アルメニア",
        AW: "アルバ",
        AC: "アセンション島",
        AU: "オーストラリア",
        AT: "オーストリア",
        AZ: "アゼルバイジャン",
        BS: "バハマ",
        BH: "バーレーン",
        BD: "バングラデシュ",
        BB: "バルバドス",
        BY: "ベラルーシ",
        BE: "ベルギー",
        BZ: "ベリーズ",
        BJ: "ベナン",
        BM: "バミューダ",
        BT: "ブータン",
        BO: "ボリビア",
        BA: "ボスニア・ヘルツェゴビナ",
        BW: "ボツワナ",
        BR: "ブラジル",
        IO: "イギリス領インド洋地域",
        BN: "ブルネイ",
        BG: "ブルガリア",
        BF: "ブルキナファソ",
        BI: "ブルンジ",
        KH: "カンボジア",
        CA: "カナダ",
        CV: "カーボベルデ",
        BQ: "カリブ・オランダ",
        KY: "ケイマン諸島",
        CF: "中央アフリカ共和国",
        TD: "チャド",
        CL: "チリ",
        CN: "中国",
        CX: "クリスマス島",
        CC: "ココス（キーリング）諸島",
        CO: "コロンビア",
        KM: "コモロ",
        CG: "コンゴ共和国",
        CD: "コンゴ民主共和国",
        CK: "クック諸島",
        CR: "コスタリカ",
        HR: "クロアチア",
        CW: "キュラソー",
        CY: "キプロス",
        CZ: "チェコ",
        CI: "コートジボワール",
        DK: "デンマーク",
        DJ: "ジブチ",
        DM: "ドミニカ国",
        DO: "ドミニカ共和国",
        EC: "エクアドル",
        EG: "エジプト",
        SV: "エルサルバドル",
        GQ: "赤道ギニア",
        ER: "エリトリア",
        EE: "エストニア",
        SZ: "エスワティニ",
        ET: "エチオピア",
        FK: "フォークランド（マルビナス）諸島",
        FO: "フェロー諸島",
        FJ: "フィジー",
        FI: "フィンランド",
        FR: "フランス",
        GF: "フランス領ギアナ",
        PF: "フランス領ポリネシア",
        TF: "フランス領南方・南極地域",
        GA: "ガボン",
        GM: "ガンビア",
        GE: "ジョージア",
        DE: "ドイツ",
        GH: "ガーナ",
        GI: "ジブラルタル",
        GR: "ギリシャ",
        GL: "グリーンランド",
        GD: "グレナダ",
        GP: "グアドループ",
        GT: "グアテマラ",
        GG: "ガーンジー",
        GN: "ギニア",
        GW: "ギニアビサウ",
        GY: "ガイアナ",
        HT: "ハイチ",
        VA: "バチカン市国",
        HN: "ホンジュラス",
        HK: "香港",
        HU: "ハンガリー",
        IS: "アイスランド",
        IN: "インド",
        ID: "インドネシア",
        IQ: "イラク",
        IE: "アイルランド",
        IM: "マン島",
        IL: "イスラエル",
        IT: "イタリア",
        JM: "ジャマイカ",
        JP: "日本",
        JE: "ジャージー",
        JO: "ヨルダン",
        KZ: "カザフスタン",
        KE: "ケニア",
        KI: "キリバス",
        XK: "コソボ",
        KW: "クウェート",
        KG: "キルギス",
        LA: "ラオス",
        LV: "ラトビア",
        LB: "レバノン",
        LS: "レソト",
        LR: "リベリア",
        LY: "リビア",
        LI: "リヒテンシュタイン",
        LT: "リトアニア",
        LU: "ルクセンブルク",
        MO: "マカオ",
        MG: "マダガスカル",
        MW: "マラウイ",
        MY: "マレーシア",
        MV: "モルディブ",
        ML: "マリ",
        MT: "マルタ",
        MQ: "マルティニーク",
        MR: "モーリタニア",
        MU: "モーリシャス",
        YT: "マヨット",
        MX: "メキシコ",
        MD: "モルドバ",
        MC: "モナコ",
        MN: "モンゴル",
        ME: "モンテネグロ",
        MS: "モントセラト",
        MA: "モロッコ",
        MZ: "モザンビーク",
        MM: "ミャンマー",
        NA: "ナミビア",
        NR: "ナウル",
        NP: "ネパール",
        NL: "オランダ",
        NC: "ニューカレドニア",
        NZ: "ニュージーランド",
        NI: "ニカラグア",
        NE: "ニジェール",
        NG: "ナイジェリア",
        NU: "ニウエ",
        NF: "ノーフォーク島",
        MK: "北マケドニア",
        NO: "ノルウェー",
        OM: "オマーン",
        PK: "パキスタン",
        PS: "パレスチナ自治区",
        PA: "パナマ",
        PG: "パプアニューギニア",
        PY: "パラグアイ",
        PE: "ペルー",
        PH: "フィリピン",
        PN: "ピトケアン島",
        PL: "ポーランド",
        PT: "ポルトガル",
        QA: "カタール",
        CM: "カメルーン",
        RE: "レユニオン",
        RO: "ルーマニア",
        RU: "ロシア",
        RW: "ルワンダ",
        BL: "サン・バルテルミー",
        SH: "セントヘレナ",
        KN: "セントクリストファー・ネイビス",
        LC: "セントルシア",
        MF: "サン・マルタン",
        PM: "サンピエール島・ミクロン島",
        WS: "サモア",
        SM: "サンマリノ",
        ST: "サントメ・プリンシペ",
        SA: "サウジアラビア",
        SN: "セネガル",
        RS: "セルビア",
        SC: "セーシェル",
        SL: "シエラレオネ",
        SG: "シンガポール",
        SX: "シント・マールテン",
        SK: "スロバキア",
        SI: "スロベニア",
        SB: "ソロモン諸島",
        SO: "ソマリア",
        ZA: "南アフリカ",
        GS: "サウスジョージア・サウスサンドウィッチ諸島",
        KR: "韓国",
        SS: "南スーダン",
        ES: "スペイン",
        LK: "スリランカ",
        VC: "セントビンセント・グレナディーン",
        SD: "スーダン",
        SR: "スリナム",
        SJ: "スバールバル・ヤンマイエン島",
        SE: "スウェーデン",
        CH: "スイス",
        TW: "台湾",
        TJ: "タジキスタン",
        TZ: "タンザニア",
        TH: "タイ",
        TL: "東ティモール",
        TG: "トーゴ",
        TK: "トケラウ",
        TO: "トンガ",
        TT: "トリニダード・トバゴ",
        TA: "トリスタン・ダ・クーニャ",
        TN: "チュニジア",
        TR: "トルコ",
        TM: "トルクメニスタン",
        TC: "タークス・カイコス諸島",
        TV: "ツバル",
        UG: "ウガンダ",
        UA: "ウクライナ",
        AE: "アラブ首長国連邦",
        GB: "イギリス",
        US: "アメリカ合衆国",
        UM: "合衆国領有小離島",
        UY: "ウルグアイ",
        UZ: "ウズベキスタン",
        VU: "バヌアツ",
        VE: "ベネズエラ",
        VN: "ベトナム",
        VG: "イギリス領ヴァージン諸島",
        WF: "ウォリス・フツナ",
        EH: "西サハラ",
        YE: "イエメン",
        ZM: "ザンビア",
        ZW: "ジンバブエ"
    };

    const COUNTRIES = [
        {
            id: 1153687617700,
            code: "AF",
            name: "Afghanistan",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/af-CtfYjyW9LCgm.svg",
            currencyCode: "AFN",
            phoneCode: 93,
            provinces: []
        },
        {
            id: 1153688928420,
            code: "AX",
            name: "Åland Islands",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ax-BzARwTbfWESz.svg",
            currencyCode: "EUR",
            phoneCode: 35818,
            provinces: []
        },
        {
            id: 1153688961188,
            code: "AL",
            name: "Albania",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/al-BipLuVbn5TNv.svg",
            currencyCode: "ALL",
            phoneCode: 355,
            provinces: []
        },
        {
            id: 1153685586084,
            code: "DZ",
            name: "Algeria",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/dz-CP5t3KQfKQHF.svg",
            currencyCode: "DZD",
            phoneCode: 213,
            provinces: []
        },
        {
            id: 1153688993956,
            code: "AD",
            name: "Andorra",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ad-BAueQZQ7FMId.svg",
            currencyCode: "EUR",
            phoneCode: 376,
            provinces: []
        },
        {
            id: 1153685618852,
            code: "AO",
            name: "Angola",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ao-Cz4G0ILK1-cI.svg",
            currencyCode: "AOA",
            phoneCode: 244,
            provinces: []
        },
        {
            id: 1153690075300,
            code: "AI",
            name: "Anguilla",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ai-BjjnBUtnfelQ.svg",
            currencyCode: "XCD",
            phoneCode: 1264,
            provinces: []
        },
        {
            id: 1153690108068,
            code: "AG",
            name: "Antigua & Barbuda",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ag-CJw2o7HWAwF0.svg",
            currencyCode: "XCD",
            phoneCode: 1268,
            provinces: []
        },
        {
            id: 1153691910308,
            code: "AR",
            name: "Argentina",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ar-CXZaB8crrpsi.svg",
            currencyCode: "ARS",
            phoneCode: 54,
            provinces: [
                { id: 12648685371556, code: "B", name: "Buenos Aires" },
                { id: 12648685404324, code: "K", name: "Catamarca" },
                { id: 12648685437092, code: "H", name: "Chaco" },
                { id: 12648685469860, code: "U", name: "Chubut" },
                { id: 12648685502628, code: "C", name: "Ciudad Autónoma de Buenos Aires" },
                { id: 12648685535396, code: "X", name: "Córdoba" },
                { id: 12648685568164, code: "W", name: "Corrientes" },
                { id: 12648685600932, code: "E", name: "Entre Ríos" },
                { id: 12648685633700, code: "P", name: "Formosa" },
                { id: 12648685666468, code: "Y", name: "Jujuy" },
                { id: 12648685699236, code: "L", name: "La Pampa" },
                { id: 12648685732004, code: "F", name: "La Rioja" },
                { id: 12648685764772, code: "M", name: "Mendoza" },
                { id: 12648685797540, code: "N", name: "Misiones" },
                { id: 12648685830308, code: "Q", name: "Neuquén" },
                { id: 12648685863076, code: "R", name: "Río Negro" },
                { id: 12648685895844, code: "A", name: "Salta" },
                { id: 12648685928612, code: "J", name: "San Juan" },
                { id: 12648685961380, code: "D", name: "San Luis" },
                { id: 12648685994148, code: "Z", name: "Santa Cruz" },
                { id: 12648686026916, code: "S", name: "Santa Fe" },
                { id: 12648686059684, code: "G", name: "Santiago Del Estero" },
                { id: 12648686092452, code: "V", name: "Tierra Del Fuego" },
                { id: 12648686125220, code: "T", name: "Tucumán" }
            ]
        },
        {
            id: 1153687650468,
            code: "AM",
            name: "Armenia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/am-Bnwp8KEp8Pbu.svg",
            currencyCode: "AMD",
            phoneCode: 374,
            provinces: []
        },
        {
            id: 1153690140836,
            code: "AW",
            name: "Aruba",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/aw-D4y0Cz9Vw_9S.svg",
            currencyCode: "AWG",
            phoneCode: 297,
            provinces: []
        },
        {
            id: 1153685651620,
            code: "AC",
            name: "Ascension Island",
            flagUrl: "",
            currencyCode: "SHP",
            phoneCode: 247,
            provinces: []
        },
        {
            id: 626905612452,
            code: "AU",
            name: "Australia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/au-XTK0rcAbsS1K.svg",
            currencyCode: "AUD",
            phoneCode: 61,
            provinces: [
                { id: 6496700727460, code: "ACT", name: "Australian Capital Territory" },
                { id: 6496700760228, code: "NSW", name: "New South Wales" },
                { id: 6496700792996, code: "NT", name: "Northern Territory" },
                { id: 6496700825764, code: "QLD", name: "Queensland" },
                { id: 6496700858532, code: "SA", name: "South Australia" },
                { id: 6496700891300, code: "TAS", name: "Tasmania" },
                { id: 6496700924068, code: "VIC", name: "Victoria" },
                { id: 6496700956836, code: "WA", name: "Western Australia" }
            ]
        },
        {
            id: 626905579684,
            code: "AT",
            name: "Austria",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/at-34JrX3vVTWwR.svg",
            currencyCode: "EUR",
            phoneCode: 43,
            provinces: []
        },
        {
            id: 1153687683236,
            code: "AZ",
            name: "Azerbaijan",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/az-B_98FsNMxWG4.svg",
            currencyCode: "AZN",
            phoneCode: 994,
            provinces: []
        },
        {
            id: 1153690173604,
            code: "BS",
            name: "Bahamas",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bs-CXKpHGk-CLqw.svg",
            currencyCode: "BSD",
            phoneCode: 1242,
            provinces: []
        },
        {
            id: 1153687716004,
            code: "BH",
            name: "Bahrain",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bh-BZMEExjJ0Vu_.svg",
            currencyCode: "",
            phoneCode: 973,
            provinces: []
        },
        {
            id: 1153687748772,
            code: "BD",
            name: "Bangladesh",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bd-CqasGyYYCggT.svg",
            currencyCode: "BDT",
            phoneCode: 880,
            provinces: []
        },
        {
            id: 1153690206372,
            code: "BB",
            name: "Barbados",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bb-mIgPTqCXIJS8.svg",
            currencyCode: "BBD",
            phoneCode: 1246,
            provinces: []
        },
        {
            id: 1153689026724,
            code: "BY",
            name: "Belarus",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/by-D1vCEx0eJJs4.svg",
            currencyCode: "",
            phoneCode: 375,
            provinces: []
        },
        {
            id: 626905645220,
            code: "BE",
            name: "Belgium",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/be-v5MaJti7JEua.svg",
            currencyCode: "EUR",
            phoneCode: 32,
            provinces: []
        },
        {
            id: 1153690239140,
            code: "BZ",
            name: "Belize",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bz-BXMadMfG-sOY.svg",
            currencyCode: "BZD",
            phoneCode: 501,
            provinces: []
        },
        {
            id: 1153685684388,
            code: "BJ",
            name: "Benin",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bj-CLF2dzQIxH4y.svg",
            currencyCode: "XOF",
            phoneCode: 229,
            provinces: []
        },
        {
            id: 1153690271908,
            code: "BM",
            name: "Bermuda",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bm-owP27Je_E3th.svg",
            currencyCode: "USD",
            phoneCode: 1441,
            provinces: []
        },
        {
            id: 1153687781540,
            code: "BT",
            name: "Bhutan",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bt-BGF_oxlljfv2.svg",
            currencyCode: "INR",
            phoneCode: 975,
            provinces: []
        },
        {
            id: 1153691943076,
            code: "BO",
            name: "Bolivia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bo-BnXEVVPZ-Jz7.svg",
            currencyCode: "BOB",
            phoneCode: 591,
            provinces: []
        },
        {
            id: 1153689059492,
            code: "BA",
            name: "Bosnia & Herzegovina",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ba-C7a1xQTLb05n.svg",
            currencyCode: "BAM",
            phoneCode: 387,
            provinces: []
        },
        {
            id: 1153685717156,
            code: "BW",
            name: "Botswana",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bw-ClD3VxOqAx2V.svg",
            currencyCode: "BWP",
            phoneCode: 267,
            provinces: []
        },
        {
            id: 1153691975844,
            code: "BR",
            name: "Brazil",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/br-DQKU8KoTeNwo.svg",
            currencyCode: "BRL",
            phoneCode: 55,
            provinces: [
                { id: 12648686157988, code: "AC", name: "Acre" },
                { id: 12648686190756, code: "AL", name: "Alagoas" },
                { id: 12648686223524, code: "AP", name: "Amapá" },
                { id: 12648686256292, code: "AM", name: "Amazonas" },
                { id: 12648686289060, code: "BA", name: "Bahia" },
                { id: 12648686321828, code: "CE", name: "Ceará" },
                { id: 12648686354596, code: "DF", name: "Distrito Federal" },
                { id: 12648686387364, code: "ES", name: "Espírito Santo" },
                { id: 12648686420132, code: "GO", name: "Goiás" },
                { id: 12648686452900, code: "MA", name: "Maranhão" },
                { id: 12648686485668, code: "MT", name: "Mato Grosso" },
                { id: 12648686518436, code: "MS", name: "Mato Grosso do Sul" },
                { id: 12648686551204, code: "MG", name: "Minas Gerais" },
                { id: 12648686583972, code: "PA", name: "Pará" },
                { id: 12648686616740, code: "PB", name: "Paraíba" },
                { id: 12648686649508, code: "PR", name: "Paraná" },
                { id: 12648686682276, code: "PE", name: "Pernambuco" },
                { id: 12648686715044, code: "PI", name: "Piauí" },
                { id: 12648686813348, code: "RJ", name: "Rio de Janeiro" },
                { id: 12648686747812, code: "RN", name: "Rio Grande do Norte" },
                { id: 12648686780580, code: "RS", name: "Rio Grande do Sul" },
                { id: 12648686846116, code: "RO", name: "Rondônia" },
                { id: 12648686878884, code: "RR", name: "Roraima" },
                { id: 12648686911652, code: "SC", name: "Santa Catarina" },
                { id: 12648686944420, code: "SP", name: "São Paulo" },
                { id: 12648686977188, code: "SE", name: "Sergipe" },
                { id: 12648687009956, code: "TO", name: "Tocantins" }
            ]
        },
        {
            id: 1153685749924,
            code: "IO",
            name: "British Indian Ocean Territory",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/io-BZD7xDKVhrxs.svg",
            currencyCode: "USD",
            phoneCode: 246,
            provinces: []
        },
        {
            id: 1153687814308,
            code: "BN",
            name: "Brunei",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bn-DZwXaeEEU2yw.svg",
            currencyCode: "BND",
            phoneCode: 673,
            provinces: []
        },
        {
            id: 1153689092260,
            code: "BG",
            name: "Bulgaria",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bg-BnCGz7CyHZHy.svg",
            currencyCode: "BGN",
            phoneCode: 359,
            provinces: []
        },
        {
            id: 1153685782692,
            code: "BF",
            name: "Burkina Faso",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bf-UFmzBopEI9UP.svg",
            currencyCode: "XOF",
            phoneCode: 226,
            provinces: []
        },
        {
            id: 1153685815460,
            code: "BI",
            name: "Burundi",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bi-C2S2ZHun41k-.svg",
            currencyCode: "BIF",
            phoneCode: 257,
            provinces: []
        },
        {
            id: 1153687847076,
            code: "KH",
            name: "Cambodia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/kh-CH4Gl5R47NPc.svg",
            currencyCode: "KHR",
            phoneCode: 855,
            provinces: []
        },
        {
            id: 626905677988,
            code: "CA",
            name: "Canada",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ca-BmTmRgSp4koy.svg",
            currencyCode: "CAD",
            phoneCode: 1,
            provinces: [
                { id: 6496700989604, code: "AB", name: "Alberta" },
                { id: 6496701022372, code: "BC", name: "British Columbia" },
                { id: 6496701055140, code: "MB", name: "Manitoba" },
                { id: 6496701087908, code: "NB", name: "New Brunswick" },
                { id: 6496701120676, code: "NL", name: "Newfoundland & Labrador" },
                { id: 6496701153444, code: "NT", name: "Northwest Territories" },
                { id: 6496701186212, code: "NS", name: "Nova Scotia" },
                { id: 6496701218980, code: "NU", name: "Nunavut" },
                { id: 6496701251748, code: "ON", name: "Ontario" },
                { id: 6496701284516, code: "PE", name: "Prince Edward Island" },
                { id: 6496701317284, code: "QC", name: "Quebec" },
                { id: 6496701350052, code: "SK", name: "Saskatchewan" },
                { id: 6496701382820, code: "YT", name: "Yukon" }
            ]
        },
        {
            id: 1153685880996,
            code: "CV",
            name: "Cape Verde",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/cv-ilQYsWVqcSRz.svg",
            currencyCode: "CVE",
            phoneCode: 238,
            provinces: []
        },
        {
            id: 1153690337444,
            code: "BQ",
            name: "Caribbean Netherlands",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bq-CLg4X62ZRe4D.svg",
            currencyCode: "USD",
            phoneCode: 599,
            provinces: []
        },
        {
            id: 1153690370212,
            code: "KY",
            name: "Cayman Islands",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ky-0OoJcNUrmHq2.svg",
            currencyCode: "KYD",
            phoneCode: 1345,
            provinces: []
        },
        {
            id: 1153685913764,
            code: "CF",
            name: "Central African Republic",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/cf-DDjcEB9UxO96.svg",
            currencyCode: "XAF",
            phoneCode: 236,
            provinces: []
        },
        {
            id: 1153685946532,
            code: "TD",
            name: "Chad",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/td-SJxMayPD0aFr.svg",
            currencyCode: "XAF",
            phoneCode: 235,
            provinces: []
        },
        {
            id: 1153692008612,
            code: "CL",
            name: "Chile",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/cl-Cw9NR8cLp8Vn.svg",
            currencyCode: "CLP",
            phoneCode: 56,
            provinces: [
                { id: 12648687108260, code: "AN", name: "Antofagasta" },
                { id: 12648687403172, code: "AR", name: "Araucanía" },
                { id: 12648687042724, code: "AP", name: "Arica & Parinacota" },
                { id: 12648687141028, code: "AT", name: "Atacama" },
                { id: 12648687501476, code: "AI", name: "Aysén" },
                { id: 12648687370404, code: "BI", name: "Biobío" },
                { id: 12648687173796, code: "CO", name: "Coquimbo" },
                { id: 12648687468708, code: "LL", name: "Los Lagos" },
                { id: 12648687435940, code: "LR", name: "Los Ríos" },
                { id: 12648687534244, code: "MA", name: "Magallanes" },
                { id: 12648687304868, code: "ML", name: "Maule" },
                { id: 12648687337636, code: "NB", name: "Ñuble" },
                { id: 12648687272100, code: "LI", name: "O'Higgins" },
                { id: 12648687239332, code: "RM", name: "Santiago" },
                { id: 12648687075492, code: "TA", name: "Tarapacá" },
                { id: 12648687206564, code: "VS", name: "Valparaíso" }
            ]
        },
        {
            id: 1153687879844,
            code: "CN",
            name: "China",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/cn-JoknfU_Z3r-X.svg",
            currencyCode: "CNY",
            phoneCode: 86,
            provinces: [
                { id: 12648669642916, code: "AH", name: "Anhui" },
                { id: 12648669675684, code: "BJ", name: "Beijing" },
                { id: 12648669708452, code: "CQ", name: "Chongqing" },
                { id: 12648669741220, code: "FJ", name: "Fujian" },
                { id: 12648669773988, code: "GS", name: "Gansu" },
                { id: 12648669806756, code: "GD", name: "Guangdong" },
                { id: 12648669839524, code: "GX", name: "Guangxi" },
                { id: 12648669872292, code: "GZ", name: "Guizhou" },
                { id: 12648669905060, code: "HI", name: "Hainan" },
                { id: 12648669937828, code: "HE", name: "Hebei" },
                { id: 12648669970596, code: "HL", name: "Heilongjiang" },
                { id: 12648670003364, code: "HA", name: "Henan" },
                { id: 12648670036132, code: "HB", name: "Hubei" },
                { id: 12648670068900, code: "HN", name: "Hunan" },
                { id: 12648670101668, code: "NM", name: "Inner Mongolia" },
                { id: 12648670134436, code: "JS", name: "Jiangsu" },
                { id: 12648670167204, code: "JX", name: "Jiangxi" },
                { id: 12648670199972, code: "JL", name: "Jilin" },
                { id: 12648670232740, code: "LN", name: "Liaoning" },
                { id: 12648670265508, code: "NX", name: "Ningxia" },
                { id: 12648670298276, code: "QH", name: "Qinghai" },
                { id: 12648670331044, code: "SN", name: "Shaanxi" },
                { id: 12648670363812, code: "SD", name: "Shandong" },
                { id: 12648670396580, code: "SH", name: "Shanghai" },
                { id: 12648670429348, code: "SX", name: "Shanxi" },
                { id: 12648670462116, code: "SC", name: "Sichuan" },
                { id: 12648670494884, code: "TJ", name: "Tianjin" },
                { id: 12648670527652, code: "XJ", name: "Xinjiang" },
                { id: 12648670560420, code: "YZ", name: "Xizang" },
                { id: 12648670593188, code: "YN", name: "Yunnan" },
                { id: 12648670625956, code: "ZJ", name: "Zhejiang" }
            ]
        },
        {
            id: 1153691254948,
            code: "CX",
            name: "Christmas Island",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/cx-Cc_JSwVUHD8T.svg",
            currencyCode: "AUD",
            phoneCode: 61,
            provinces: []
        },
        {
            id: 1153691287716,
            code: "CC",
            name: "Cocos (Keeling) Islands",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/cc-B0KcFz6YNJ9l.svg",
            currencyCode: "AUD",
            phoneCode: 61,
            provinces: []
        },
        {
            id: 1153692041380,
            code: "CO",
            name: "Colombia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/co-CTEUF9PJZeep.svg",
            currencyCode: "COP",
            phoneCode: 57,
            provinces: [
                { id: 12648687599780, code: "AMA", name: "Amazonas" },
                { id: 12648687632548, code: "ANT", name: "Antioquia" },
                { id: 12648687665316, code: "ARA", name: "Arauca" },
                { id: 12648687698084, code: "ATL", name: "Atlántico" },
                { id: 12648687567012, code: "DC", name: "Bogotá, D.C." },
                { id: 12648687730852, code: "BOL", name: "Bolívar" },
                { id: 12648687763620, code: "BOY", name: "Boyacá" },
                { id: 12648687796388, code: "CAL", name: "Caldas" },
                { id: 12648687829156, code: "CAQ", name: "Caquetá" },
                { id: 12648687861924, code: "CAS", name: "Casanare" },
                { id: 12648687894692, code: "CAU", name: "Cauca" },
                { id: 12648687927460, code: "CES", name: "Cesar" },
                { id: 12648687960228, code: "CHO", name: "Chocó" },
                { id: 12648687992996, code: "COR", name: "Córdoba" },
                { id: 12648688025764, code: "CUN", name: "Cundinamarca" },
                { id: 12648688058532, code: "GUA", name: "Guainía" },
                { id: 12648688091300, code: "GUV", name: "Guaviare" },
                { id: 12648688124068, code: "HUI", name: "Huila" },
                { id: 12648688156836, code: "LAG", name: "La Guajira" },
                { id: 12648688189604, code: "MAG", name: "Magdalena" },
                { id: 12648688222372, code: "MET", name: "Meta" },
                { id: 12648688255140, code: "NAR", name: "Nariño" },
                { id: 12648688287908, code: "NSA", name: "Norte de Santander" },
                { id: 12648688320676, code: "PUT", name: "Putumayo" },
                { id: 12648688353444, code: "QUI", name: "Quindío" },
                { id: 12648688386212, code: "RIS", name: "Risaralda" },
                { id: 12648688418980, code: "SAP", name: "San Andrés, Providencia y Santa Catalina" },
                { id: 12648688451748, code: "SAN", name: "Santander" },
                { id: 12648688484516, code: "SUC", name: "Sucre" },
                { id: 12648688517284, code: "TOL", name: "Tolima" },
                { id: 12648688550052, code: "VAC", name: "Valle del Cauca" },
                { id: 12648688582820, code: "VAU", name: "Vaupés" },
                { id: 12648688615588, code: "VID", name: "Vichada" }
            ]
        },
        {
            id: 1153685979300,
            code: "KM",
            name: "Comoros",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/km-AzKDvAf_vmlj.svg",
            currencyCode: "KMF",
            phoneCode: 269,
            provinces: []
        },
        {
            id: 1153686012068,
            code: "CG",
            name: "Congo",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/cg-l-GXfw9VNXwM.svg",
            currencyCode: "XAF",
            phoneCode: 242,
            provinces: []
        },
        {
            id: 1153686044836,
            code: "CD",
            name: "Congo - Kinshasa",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/cd-1f9CfmwDcK8b.svg",
            currencyCode: "CDF",
            phoneCode: 243,
            provinces: []
        },
        {
            id: 1153691320484,
            code: "CK",
            name: "Cook Islands",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ck-BO0vbk-DzsNc.svg",
            currencyCode: "NZD",
            phoneCode: 682,
            provinces: []
        },
        {
            id: 1153690402980,
            code: "CR",
            name: "Costa Rica",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/cr-CyQxjSrva0l_.svg",
            currencyCode: "CRC",
            phoneCode: 506,
            provinces: [
                { id: 12648682487972, code: "CR-A", name: "Alajuela" },
                { id: 12648682520740, code: "CR-C", name: "Cartago" },
                { id: 12648682553508, code: "CR-G", name: "Guanacaste" },
                { id: 12648682586276, code: "CR-H", name: "Heredia" },
                { id: 12648682619044, code: "CR-L", name: "Limón" },
                { id: 12648682651812, code: "CR-P", name: "Puntarenas" },
                { id: 12648682684580, code: "CR-SJ", name: "San José" }
            ]
        },
        {
            id: 1153689125028,
            code: "HR",
            name: "Croatia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/hr-rCBb7Lb5Y7I0.svg",
            currencyCode: "EUR",
            phoneCode: 385,
            provinces: []
        },
        {
            id: 1153690435748,
            code: "CW",
            name: "Curaçao",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/cw-C52PGJ8eYA2B.svg",
            currencyCode: "ANG",
            phoneCode: 599,
            provinces: []
        },
        {
            id: 1153687912612,
            code: "CY",
            name: "Cyprus",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/cy-B3SuHvcYRYuq.svg",
            currencyCode: "EUR",
            phoneCode: 357,
            provinces: []
        },
        {
            id: 626905743524,
            code: "CZ",
            name: "Czechia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/cz-CCEdEuzi8cAR.svg",
            currencyCode: "CZK",
            phoneCode: 420,
            provinces: []
        },
        {
            id: 1153686077604,
            code: "CI",
            name: "Côte d'Ivoire",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ci-DYzagfnRXH0L.svg",
            currencyCode: "XOF",
            phoneCode: 225,
            provinces: []
        },
        {
            id: 626905809060,
            code: "DK",
            name: "Denmark",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/dk-CuxTe9FbAjsv.svg",
            currencyCode: "DKK",
            phoneCode: 45,
            provinces: []
        },
        {
            id: 1153686110372,
            code: "DJ",
            name: "Djibouti",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/dj-CMkRaV9w7XSe.svg",
            currencyCode: "DJF",
            phoneCode: 253,
            provinces: []
        },
        {
            id: 1153690468516,
            code: "DM",
            name: "Dominica",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/dm-B4yD1K3JSKtv.svg",
            currencyCode: "XCD",
            phoneCode: 1767,
            provinces: []
        },
        {
            id: 1153690501284,
            code: "DO",
            name: "Dominican Republic",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/do-BL75qdD4Dr-m.svg",
            currencyCode: "DOP",
            phoneCode: 1,
            provinces: []
        },
        {
            id: 1153692074148,
            code: "EC",
            name: "Ecuador",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ec-HhpxILaX0fXr.svg",
            currencyCode: "USD",
            phoneCode: 593,
            provinces: []
        },
        {
            id: 1153686143140,
            code: "EG",
            name: "Egypt",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/eg-CTMekvvUmzdB.svg",
            currencyCode: "EGP",
            phoneCode: 20,
            provinces: [
                { id: 12648667185316, code: "SU", name: "6th of October" },
                { id: 12648667218084, code: "SHR", name: "Al Sharqia" },
                { id: 12648667250852, code: "ALX", name: "Alexandria" },
                { id: 12648667283620, code: "ASN", name: "Aswan" },
                { id: 12648667316388, code: "AST", name: "Asyut" },
                { id: 12648667349156, code: "BH", name: "Beheira" },
                { id: 12648667381924, code: "BNS", name: "Beni Suef" },
                { id: 12648667414692, code: "C", name: "Cairo" },
                { id: 12648667447460, code: "DK", name: "Dakahlia" },
                { id: 12648667480228, code: "DT", name: "Damietta" },
                { id: 12648667512996, code: "FYM", name: "Faiyum" },
                { id: 12648667545764, code: "GH", name: "Gharbia" },
                { id: 12648667578532, code: "GZ", name: "Giza" },
                { id: 12648667611300, code: "HU", name: "Helwan" },
                { id: 12648667644068, code: "IS", name: "Ismailia" },
                { id: 12648667676836, code: "KFS", name: "Kafr el-Sheikh" },
                { id: 12648667709604, code: "LX", name: "Luxor" },
                { id: 12648667742372, code: "MT", name: "Matrouh" },
                { id: 12648667775140, code: "MN", name: "Minya" },
                { id: 12648667807908, code: "MNF", name: "Monufia" },
                { id: 12648667840676, code: "WAD", name: "New Valley" },
                { id: 12648667873444, code: "SIN", name: "North Sinai" },
                { id: 12648667906212, code: "PTS", name: "Port Said" },
                { id: 12648667938980, code: "KB", name: "Qalyubia" },
                { id: 12648667971748, code: "KN", name: "Qena" },
                { id: 12648668004516, code: "BA", name: "Red Sea" },
                { id: 12648668037284, code: "SHG", name: "Sohag" },
                { id: 12648668070052, code: "JS", name: "South Sinai" },
                { id: 12648668102820, code: "SUZ", name: "Suez" }
            ]
        },
        {
            id: 1153690534052,
            code: "SV",
            name: "El Salvador",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/sv-IhUWuI9F4oLi.svg",
            currencyCode: "USD",
            phoneCode: 503,
            provinces: [
                { id: 12648682717348, code: "SV-AH", name: "Ahuachapán" },
                { id: 12648682750116, code: "SV-CA", name: "Cabañas" },
                { id: 12648682782884, code: "SV-CH", name: "Chalatenango" },
                { id: 12648682815652, code: "SV-CU", name: "Cuscatlán" },
                { id: 12648682848420, code: "SV-LI", name: "La Libertad" },
                { id: 12648682881188, code: "SV-PA", name: "La Paz" },
                { id: 12648682913956, code: "SV-UN", name: "La Unión" },
                { id: 12648682946724, code: "SV-MO", name: "Morazán" },
                { id: 12648682979492, code: "SV-SM", name: "San Miguel" },
                { id: 12648683012260, code: "SV-SS", name: "San Salvador" },
                { id: 12648683045028, code: "SV-SV", name: "San Vicente" },
                { id: 12648683077796, code: "SV-SA", name: "Santa Ana" },
                { id: 12648683110564, code: "SV-SO", name: "Sonsonate" },
                { id: 12648683143332, code: "SV-US", name: "Usulután" }
            ]
        },
        {
            id: 1153686175908,
            code: "GQ",
            name: "Equatorial Guinea",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/gq-DsLt_giQTVd9.svg",
            currencyCode: "XAF",
            phoneCode: 240,
            provinces: []
        },
        {
            id: 1153686208676,
            code: "ER",
            name: "Eritrea",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/er-GCOTTxa_DrWd.svg",
            currencyCode: "",
            phoneCode: 291,
            provinces: []
        },
        {
            id: 1153689157796,
            code: "EE",
            name: "Estonia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ee-CYfy3sgDeGvi.svg",
            currencyCode: "EUR",
            phoneCode: 372,
            provinces: []
        },
        {
            id: 1153686241444,
            code: "SZ",
            name: "Eswatini",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/sz-D0BNmkP7FCG2.svg",
            currencyCode: "SZL",
            phoneCode: 268,
            provinces: []
        },
        {
            id: 1153686274212,
            code: "ET",
            name: "Ethiopia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/et-KSh5XvtteZC3.svg",
            currencyCode: "ETB",
            phoneCode: 251,
            provinces: []
        },
        {
            id: 1153692106916,
            code: "FK",
            name: "Falkland Islands (Malvinas)",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/fk-DBAk-mvDWHUU.svg",
            currencyCode: "FKP",
            phoneCode: 500,
            provinces: []
        },
        {
            id: 1153689190564,
            code: "FO",
            name: "Faroe Islands",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/fo-bj0gQ8-Y8WjH.svg",
            currencyCode: "DKK",
            phoneCode: 298,
            provinces: []
        },
        {
            id: 1153691353252,
            code: "FJ",
            name: "Fiji",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/fj-DSBdLQz2eAs0.svg",
            currencyCode: "FJD",
            phoneCode: 679,
            provinces: []
        },
        {
            id: 626905874596,
            code: "FI",
            name: "Finland",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/fi-ql-MnHJYvAfk.svg",
            currencyCode: "EUR",
            phoneCode: 358,
            provinces: []
        },
        {
            id: 626905907364,
            code: "FR",
            name: "France",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/fr-CvJDduywicne.svg",
            currencyCode: "EUR",
            phoneCode: 33,
            provinces: []
        },
        {
            id: 1153692139684,
            code: "GF",
            name: "French Guiana",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/gf-eepjRsnY4cYB.svg",
            currencyCode: "EUR",
            phoneCode: 594,
            provinces: []
        },
        {
            id: 1153691386020,
            code: "PF",
            name: "French Polynesia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/pf-BPRqB5756bbZ.svg",
            currencyCode: "XPF",
            phoneCode: 689,
            provinces: []
        },
        {
            id: 1153686306980,
            code: "TF",
            name: "French Southern Territories",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/tf-DHFGsmLOzrXo.svg",
            currencyCode: "EUR",
            phoneCode: 262,
            provinces: []
        },
        {
            id: 1153686339748,
            code: "GA",
            name: "Gabon",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ga-BQqL3B9DUrLi.svg",
            currencyCode: "XOF",
            phoneCode: 241,
            provinces: []
        },
        {
            id: 1153686372516,
            code: "GM",
            name: "Gambia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/gm-DQKA5sIBPG3K.svg",
            currencyCode: "GMD",
            phoneCode: 220,
            provinces: []
        },
        {
            id: 1153687945380,
            code: "GE",
            name: "Georgia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ge-p2goQqNKHn3i.svg",
            currencyCode: "",
            phoneCode: 995,
            provinces: []
        },
        {
            id: 626905776292,
            code: "DE",
            name: "Germany",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/de-QIkpdT_kUNZ6.svg",
            currencyCode: "EUR",
            phoneCode: 49,
            provinces: []
        },
        {
            id: 1153686405284,
            code: "GH",
            name: "Ghana",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/gh-u8q88LNE48s-.svg",
            currencyCode: "",
            phoneCode: 233,
            provinces: []
        },
        {
            id: 1153689223332,
            code: "GI",
            name: "Gibraltar",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/gi-CDZUSDLVpkKK.svg",
            currencyCode: "GBP",
            phoneCode: 350,
            provinces: []
        },
        {
            id: 1153689256100,
            code: "GR",
            name: "Greece",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/gr-BfBZdHv1jcLj.svg",
            currencyCode: "EUR",
            phoneCode: 30,
            provinces: []
        },
        {
            id: 1153690566820,
            code: "GL",
            name: "Greenland",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/gl-VFSi-r-68OtV.svg",
            currencyCode: "DKK",
            phoneCode: 299,
            provinces: []
        },
        {
            id: 1153690599588,
            code: "GD",
            name: "Grenada",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/gd-Drjl2PnwNoxp.svg",
            currencyCode: "XCD",
            phoneCode: 1473,
            provinces: []
        },
        {
            id: 1153690632356,
            code: "GP",
            name: "Guadeloupe",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/fr-CvJDduywicne.svg",
            currencyCode: "EUR",
            phoneCode: 590,
            provinces: []
        },
        {
            id: 1153690665124,
            code: "GT",
            name: "Guatemala",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/gt-DwIh7i-ap9BJ.svg",
            currencyCode: "GTQ",
            phoneCode: 502,
            provinces: [
                { id: 12648683176100, code: "AVE", name: "Alta Verapaz" },
                { id: 12648683208868, code: "BVE", name: "Baja Verapaz" },
                { id: 12648683241636, code: "CMT", name: "Chimaltenango" },
                { id: 12648683274404, code: "CQM", name: "Chiquimula" },
                { id: 12648683307172, code: "EPR", name: "El Progreso" },
                { id: 12648683339940, code: "ESC", name: "Escuintla" },
                { id: 12648683372708, code: "GUA", name: "Guatemala" },
                { id: 12648683405476, code: "HUE", name: "Huehuetenango" },
                { id: 12648683438244, code: "IZA", name: "Izabal" },
                { id: 12648683471012, code: "JAL", name: "Jalapa" },
                { id: 12648683503780, code: "JUT", name: "Jutiapa" },
                { id: 12648683536548, code: "PET", name: "Petén" },
                { id: 12648683569316, code: "QUE", name: "Quetzaltenango" },
                { id: 12648683602084, code: "QUI", name: "Quiché" },
                { id: 12648683634852, code: "RET", name: "Retalhuleu" },
                { id: 12648683667620, code: "SAC", name: "Sacatepéquez" },
                { id: 12648683700388, code: "SMA", name: "San Marcos" },
                { id: 12648683733156, code: "SRO", name: "Santa Rosa" },
                { id: 12648683765924, code: "SOL", name: "Sololá" },
                { id: 12648683798692, code: "SUC", name: "Suchitepéquez" },
                { id: 12648683831460, code: "TOT", name: "Totonicapán" },
                { id: 12648683864228, code: "ZAC", name: "Zacapa" }
            ]
        },
        {
            id: 1153689288868,
            code: "GG",
            name: "Guernsey",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/gg-CRObib7OZb29.svg",
            currencyCode: "GBP",
            phoneCode: 44,
            provinces: []
        },
        {
            id: 1153686438052,
            code: "GN",
            name: "Guinea",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/gn-B3qInJCuo_2Y.svg",
            currencyCode: "GNF",
            phoneCode: 224,
            provinces: []
        },
        {
            id: 1153686470820,
            code: "GW",
            name: "Guinea Bissau",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/gw-B7fBUocT5BJV.svg",
            currencyCode: "XOF",
            phoneCode: 245,
            provinces: []
        },
        {
            id: 1153692172452,
            code: "GY",
            name: "Guyana",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/gy-HDrnPHNIYdLd.svg",
            currencyCode: "GYD",
            phoneCode: 592,
            provinces: []
        },
        {
            id: 1153690697892,
            code: "HT",
            name: "Haiti",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ht-DnizvfU744NV.svg",
            currencyCode: "HTG",
            phoneCode: 509,
            provinces: []
        },
        {
            id: 1153690042532,
            code: "VA",
            name: "Vatican City",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/va-HKheKEUQxUsU.svg",
            currencyCode: "EUR",
            phoneCode: 39,
            provinces: []
        },
        {
            id: 1153690730660,
            code: "HN",
            name: "Honduras",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/hn-DZdvEQLGEiQk.svg",
            currencyCode: "HNL",
            phoneCode: 504,
            provinces: []
        },
        {
            id: 626905972900,
            code: "HK",
            name: "Hong Kong SAR",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/hk-DQKxLB8pP9Di.svg",
            currencyCode: "HKD",
            phoneCode: 852,
            provinces: [
                { id: 6496703283364, code: "HK", name: "Hong Kong Island" },
                { id: 6496703316132, code: "KL", name: "Kowloon" },
                { id: 6496703348900, code: "NT", name: "New Territories" }
            ]
        },
        {
            id: 1153689321636,
            code: "HU",
            name: "Hungary",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/hu-DeLqwUS30SR-.svg",
            currencyCode: "HUF",
            phoneCode: 36,
            provinces: []
        },
        {
            id: 1153689354404,
            code: "IS",
            name: "Iceland",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/is-DEWi2QFDXZHH.svg",
            currencyCode: "ISK",
            phoneCode: 354,
            provinces: []
        },
        {
            id: 1153687978148,
            code: "IN",
            name: "India",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/in-5QH_r_CK76bz.svg",
            currencyCode: "INR",
            phoneCode: 91,
            provinces: [
                { id: 12648670658724, code: "AN", name: "Andaman & Nicobar Islands" },
                { id: 12648670691492, code: "AP", name: "Andhra Pradesh" },
                { id: 12648670724260, code: "AR", name: "Arunachal Pradesh" },
                { id: 12648670757028, code: "AS", name: "Assam" },
                { id: 12648670789796, code: "BR", name: "Bihar" },
                { id: 12648670822564, code: "CH", name: "Chandigarh" },
                { id: 12648670855332, code: "CG", name: "Chhattisgarh" },
                { id: 12648670888100, code: "DN", name: "Dadra & Nagar Haveli" },
                { id: 12648670920868, code: "DD", name: "Daman & Diu" },
                { id: 12648670953636, code: "DL", name: "Delhi" },
                { id: 12648670986404, code: "GA", name: "Goa" },
                { id: 12648671019172, code: "GJ", name: "Gujarat" },
                { id: 12648671051940, code: "HR", name: "Haryana" },
                { id: 12648671084708, code: "HP", name: "Himachal Pradesh" },
                { id: 12648671117476, code: "JK", name: "Jammu & Kashmir" },
                { id: 12648671150244, code: "JH", name: "Jharkhand" },
                { id: 12648671183012, code: "KA", name: "Karnataka" },
                { id: 12648671215780, code: "KL", name: "Kerala" },
                { id: 12648671248548, code: "LA", name: "Ladakh" },
                { id: 12648671281316, code: "LD", name: "Lakshadweep" },
                { id: 12648671314084, code: "MP", name: "Madhya Pradesh" },
                { id: 12648671346852, code: "MH", name: "Maharashtra" },
                { id: 12648671379620, code: "MN", name: "Manipur" },
                { id: 12648671412388, code: "ML", name: "Meghalaya" },
                { id: 12648671445156, code: "MZ", name: "Mizoram" },
                { id: 12648671477924, code: "NL", name: "Nagaland" },
                { id: 12648671510692, code: "OR", name: "Odisha" },
                { id: 12648671543460, code: "PY", name: "Puducherry" },
                { id: 12648671576228, code: "PB", name: "Punjab" },
                { id: 12648671608996, code: "RJ", name: "Rajasthan" },
                { id: 12648671641764, code: "SK", name: "Sikkim" },
                { id: 12648671674532, code: "TN", name: "Tamil Nadu" },
                { id: 12648671707300, code: "TS", name: "Telangana" },
                { id: 12648671740068, code: "TR", name: "Tripura" },
                { id: 12648671772836, code: "UP", name: "Uttar Pradesh" },
                { id: 12648671805604, code: "UK", name: "Uttarakhand" },
                { id: 12648671838372, code: "WB", name: "West Bengal" }
            ]
        },
        {
            id: 1153688010916,
            code: "ID",
            name: "Indonesia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/id-BEoOSM93Z6xJ.svg",
            currencyCode: "IDR",
            phoneCode: 62,
            provinces: [
                { id: 12648671871140, code: "AC", name: "Aceh" },
                { id: 12648671903908, code: "BA", name: "Bali" },
                { id: 12648671936676, code: "BB", name: "Bangka Belitung" },
                { id: 12648671969444, code: "BT", name: "Banten" },
                { id: 12648672002212, code: "BE", name: "Bengkulu" },
                { id: 12648672034980, code: "GO", name: "Gorontalo" },
                { id: 12648672067748, code: "JK", name: "Jakarta" },
                { id: 12648672100516, code: "JA", name: "Jambi" },
                { id: 12648672133284, code: "JB", name: "Jawa Barat" },
                { id: 12648672166052, code: "JT", name: "Jawa Tengah" },
                { id: 12648672198820, code: "JI", name: "Jawa Timur" },
                { id: 12648672231588, code: "KB", name: "Kalimantan Barat" },
                { id: 12648672264356, code: "KS", name: "Kalimantan Selatan" },
                { id: 12648672297124, code: "KT", name: "Kalimantan Tengah" },
                { id: 12648672329892, code: "KI", name: "Kalimantan Timur" },
                { id: 12648672362660, code: "KU", name: "Kalimantan Utara" },
                { id: 12648672395428, code: "KR", name: "Kepulauan Riau" },
                { id: 12648672428196, code: "LA", name: "Lampung" },
                { id: 12648672460964, code: "MA", name: "Maluku" },
                { id: 12648672493732, code: "MU", name: "Maluku Utara" },
                { id: 12648672526500, code: "SU", name: "North Sumatra" },
                { id: 12648672559268, code: "NB", name: "Nusa Tenggara Barat" },
                { id: 12648672592036, code: "NT", name: "Nusa Tenggara Timur" },
                { id: 12648672624804, code: "PA", name: "Papua" },
                { id: 12648672657572, code: "PB", name: "Papua Barat" },
                { id: 12648672690340, code: "RI", name: "Riau" },
                { id: 12648672723108, code: "SS", name: "South Sumatra" },
                { id: 12648672755876, code: "SR", name: "Sulawesi Barat" },
                { id: 12648672788644, code: "SN", name: "Sulawesi Selatan" },
                { id: 12648672821412, code: "ST", name: "Sulawesi Tengah" },
                { id: 12648672854180, code: "SG", name: "Sulawesi Tenggara" },
                { id: 12648672886948, code: "SA", name: "Sulawesi Utara" },
                { id: 12648672919716, code: "SB", name: "West Sumatra" },
                { id: 12648672952484, code: "YO", name: "Yogyakarta" }
            ]
        },
        {
            id: 1153688043684,
            code: "IQ",
            name: "Iraq",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/iq-De6Ewn5cRC8X.svg",
            currencyCode: "",
            phoneCode: 964,
            provinces: []
        },
        {
            id: 626906005668,
            code: "IE",
            name: "Ireland",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ie-CL2bapxvVt-K.svg",
            currencyCode: "EUR",
            phoneCode: 353,
            provinces: [
                { id: 6496703381668, code: "CW", name: "Carlow" },
                { id: 6496703414436, code: "CN", name: "Cavan" },
                { id: 6496703447204, code: "CE", name: "Clare" },
                { id: 6496703479972, code: "CO", name: "Cork" },
                { id: 6496703512740, code: "DL", name: "Donegal" },
                { id: 6496703545508, code: "D", name: "Dublin" },
                { id: 6496703578276, code: "G", name: "Galway" },
                { id: 6496703611044, code: "KY", name: "Kerry" },
                { id: 6496703643812, code: "KE", name: "Kildare" },
                { id: 6496703676580, code: "KK", name: "Kilkenny" },
                { id: 6496703709348, code: "LS", name: "Laois" },
                { id: 6496703742116, code: "LM", name: "Leitrim" },
                { id: 6496703774884, code: "LK", name: "Limerick" },
                { id: 6496703807652, code: "LD", name: "Longford" },
                { id: 6496703840420, code: "LH", name: "Louth" },
                { id: 6496703873188, code: "MO", name: "Mayo" },
                { id: 6496703905956, code: "MH", name: "Meath" },
                { id: 6496703938724, code: "MN", name: "Monaghan" },
                { id: 6496703971492, code: "OY", name: "Offaly" },
                { id: 6496704004260, code: "RN", name: "Roscommon" },
                { id: 6496704037028, code: "SO", name: "Sligo" },
                { id: 6496704069796, code: "TA", name: "Tipperary" },
                { id: 6496704102564, code: "WD", name: "Waterford" },
                { id: 6496704135332, code: "WH", name: "Westmeath" },
                { id: 6496704168100, code: "WX", name: "Wexford" },
                { id: 6496704200868, code: "WW", name: "Wicklow" }
            ]
        },
        {
            id: 1153689387172,
            code: "IM",
            name: "Isle Of Man",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/im-pEB6D7i7fdr6.svg",
            currencyCode: "GBP",
            phoneCode: 44,
            provinces: []
        },
        {
            id: 626906038436,
            code: "IL",
            name: "Israel",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/il-D-ILqwhlXB0V.svg",
            currencyCode: "ILS",
            phoneCode: 972,
            provinces: []
        },
        {
            id: 626906071204,
            code: "IT",
            name: "Italy",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/it-19TCnoAF0Naq.svg",
            currencyCode: "EUR",
            phoneCode: 39,
            provinces: [
                { id: 6496704233636, code: "AG", name: "Agrigento" },
                { id: 6496704266404, code: "AL", name: "Alessandria" },
                { id: 6496704299172, code: "AN", name: "Ancona" },
                { id: 6496704331940, code: "AO", name: "Aosta" },
                { id: 6496704364708, code: "AR", name: "Arezzo" },
                { id: 6496704397476, code: "AP", name: "Ascoli Piceno" },
                { id: 6496704430244, code: "AT", name: "Asti" },
                { id: 6496704463012, code: "AV", name: "Avellino" },
                { id: 6496704495780, code: "BA", name: "Bari" },
                { id: 6496704528548, code: "BT", name: "Barletta-Andria-Trani" },
                { id: 6496704561316, code: "BL", name: "Belluno" },
                { id: 6496704594084, code: "BN", name: "Benevento" },
                { id: 6496704626852, code: "BG", name: "Bergamo" },
                { id: 6496704659620, code: "BI", name: "Biella" },
                { id: 6496704692388, code: "BO", name: "Bologna" },
                { id: 6496704725156, code: "BZ", name: "Bolzano" },
                { id: 6496704757924, code: "BS", name: "Brescia" },
                { id: 6496704790692, code: "BR", name: "Brindisi" },
                { id: 6496704823460, code: "CA", name: "Cagliari" },
                { id: 6496704856228, code: "CL", name: "Caltanissetta" },
                { id: 6496704888996, code: "CB", name: "Campobasso" },
                { id: 6496704921764, code: "CI", name: "Carbonia-Iglesias" },
                { id: 6496704954532, code: "CE", name: "Caserta" },
                { id: 6496704987300, code: "CT", name: "Catania" },
                { id: 6496705020068, code: "CZ", name: "Catanzaro" },
                { id: 6496705052836, code: "CH", name: "Chieti" },
                { id: 6496705085604, code: "CO", name: "Como" },
                { id: 6496705118372, code: "CS", name: "Cosenza" },
                { id: 6496705151140, code: "CR", name: "Cremona" },
                { id: 6496705183908, code: "KR", name: "Crotone" },
                { id: 6496705216676, code: "CN", name: "Cuneo" },
                { id: 6496705249444, code: "EN", name: "Enna" },
                { id: 6496705282212, code: "FM", name: "Fermo" },
                { id: 6496705314980, code: "FE", name: "Ferrara" },
                { id: 6496705347748, code: "FI", name: "Firenze" },
                { id: 6496705380516, code: "FG", name: "Foggia" },
                { id: 6496705413284, code: "FC", name: "Forlì-Cesena" },
                { id: 6496705446052, code: "FR", name: "Frosinone" },
                { id: 6496705478820, code: "GE", name: "Genova" },
                { id: 6496705511588, code: "GO", name: "Gorizia" },
                { id: 6496705544356, code: "GR", name: "Grosseto" },
                { id: 6496705577124, code: "IM", name: "Imperia" },
                { id: 6496705609892, code: "IS", name: "Isernia" },
                { id: 6496705642660, code: "AQ", name: "L'Aquila" },
                { id: 6496705675428, code: "SP", name: "La Spezia" },
                { id: 6496705708196, code: "LT", name: "Latina" },
                { id: 6496705740964, code: "LE", name: "Lecce" },
                { id: 6496705773732, code: "LC", name: "Lecco" },
                { id: 6496705806500, code: "LI", name: "Livorno" },
                { id: 6496705839268, code: "LO", name: "Lodi" },
                { id: 6496705872036, code: "LU", name: "Lucca" },
                { id: 6496705904804, code: "MC", name: "Macerata" },
                { id: 6496705937572, code: "MN", name: "Mantova" },
                { id: 6496705970340, code: "MS", name: "Massa-Carrara" },
                { id: 6496706003108, code: "MT", name: "Matera" },
                { id: 6496706035876, code: "VS", name: "Medio Campidano" },
                { id: 6496706068644, code: "ME", name: "Messina" },
                { id: 6496706101412, code: "MI", name: "Milano" },
                { id: 6496706134180, code: "MO", name: "Modena" },
                { id: 6496706166948, code: "MB", name: "Monza e Brianza" },
                { id: 6496706199716, code: "NA", name: "Napoli" },
                { id: 6496706232484, code: "NO", name: "Novara" },
                { id: 6496706265252, code: "NU", name: "Nuoro" },
                { id: 6496706298020, code: "OG", name: "Ogliastra" },
                { id: 6496706330788, code: "OT", name: "Olbia-Tempio" },
                { id: 6496706363556, code: "OR", name: "Oristano" },
                { id: 6496706396324, code: "PD", name: "Padova" },
                { id: 6496706429092, code: "PA", name: "Palermo" },
                { id: 6496706461860, code: "PR", name: "Parma" },
                { id: 6496706494628, code: "PV", name: "Pavia" },
                { id: 6496706527396, code: "PG", name: "Perugia" },
                { id: 6496706560164, code: "PU", name: "Pesaro e Urbino" },
                { id: 6496706592932, code: "PE", name: "Pescara" },
                { id: 6496706625700, code: "PC", name: "Piacenza" },
                { id: 6496706658468, code: "PI", name: "Pisa" },
                { id: 6496706691236, code: "PT", name: "Pistoia" },
                { id: 6496706724004, code: "PN", name: "Pordenone" },
                { id: 6496706756772, code: "PZ", name: "Potenza" },
                { id: 6496706789540, code: "PO", name: "Prato" },
                { id: 6496706822308, code: "RG", name: "Ragusa" },
                { id: 6496706855076, code: "RA", name: "Ravenna" },
                { id: 6496706887844, code: "RC", name: "Reggio Calabria" },
                { id: 6496706920612, code: "RE", name: "Reggio Emilia" },
                { id: 6496706953380, code: "RI", name: "Rieti" },
                { id: 6496706986148, code: "RN", name: "Rimini" },
                { id: 6496707018916, code: "RM", name: "Roma" },
                { id: 6496707051684, code: "RO", name: "Rovigo" },
                { id: 6496707084452, code: "SA", name: "Salerno" },
                { id: 6496707117220, code: "SS", name: "Sassari" },
                { id: 6496707149988, code: "SV", name: "Savona" },
                { id: 6496707182756, code: "SI", name: "Siena" },
                { id: 6496707215524, code: "SR", name: "Siracusa" },
                { id: 6496707248292, code: "SO", name: "Sondrio" },
                { id: 6496707281060, code: "TA", name: "Taranto" },
                { id: 6496707313828, code: "TE", name: "Teramo" },
                { id: 6496707346596, code: "TR", name: "Terni" },
                { id: 6496707379364, code: "TO", name: "Torino" },
                { id: 6496707412132, code: "TP", name: "Trapani" },
                { id: 6496707444900, code: "TN", name: "Trento" },
                { id: 6496707477668, code: "TV", name: "Treviso" },
                { id: 6496707510436, code: "TS", name: "Trieste" },
                { id: 6496707543204, code: "UD", name: "Udine" },
                { id: 6496707575972, code: "VA", name: "Varese" },
                { id: 6496707608740, code: "VE", name: "Venezia" },
                { id: 6496707641508, code: "VB", name: "Verbano-Cusio-Ossola" },
                { id: 6496707674276, code: "VC", name: "Vercelli" },
                { id: 6496707707044, code: "VR", name: "Verona" },
                { id: 6496707739812, code: "VV", name: "Vibo Valentia" },
                { id: 6496707772580, code: "VI", name: "Vicenza" },
                { id: 6496707805348, code: "VT", name: "Viterbo" }
            ]
        },
        {
            id: 1153690763428,
            code: "JM",
            name: "Jamaica",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/jm-BcM9ggJJKx3f.svg",
            currencyCode: "JMD",
            phoneCode: 1,
            provinces: []
        },
        {
            id: 626906103972,
            code: "JP",
            name: "Japan",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/jp-CTWEPhDVJxi7.svg",
            currencyCode: "JPY",
            phoneCode: 81,
            provinces: [
                { id: 6496708559012, code: "JP-23", name: "Aichi" },
                { id: 6496707969188, code: "JP-05", name: "Akita" },
                { id: 6496707870884, code: "JP-02", name: "Aomori" },
                { id: 6496708198564, code: "JP-12", name: "Chiba" },
                { id: 6496709050532, code: "JP-38", name: "Ehime" },
                { id: 6496708395172, code: "JP-18", name: "Fukui" },
                { id: 6496709116068, code: "JP-40", name: "Fukuoka" },
                { id: 6496708034724, code: "JP-07", name: "Fukushima" },
                { id: 6496708493476, code: "JP-21", name: "Gifu" },
                { id: 6496708133028, code: "JP-10", name: "Gunma" },
                { id: 6496708919460, code: "JP-34", name: "Hiroshima" },
                { id: 6496707838116, code: "JP-01", name: "Hokkaidō" },
                { id: 6496708722852, code: "JP-28", name: "Hyōgo" },
                { id: 6496708067492, code: "JP-08", name: "Ibaraki" },
                { id: 6496708362404, code: "JP-17", name: "Ishikawa" },
                { id: 6496707903652, code: "JP-03", name: "Iwate" },
                { id: 6496709017764, code: "JP-37", name: "Kagawa" },
                { id: 6496709312676, code: "JP-46", name: "Kagoshima" },
                { id: 6496708264100, code: "JP-14", name: "Kanagawa" },
                { id: 6496709083300, code: "JP-39", name: "Kōchi" },
                { id: 6496709214372, code: "JP-43", name: "Kumamoto" },
                { id: 6496708657316, code: "JP-26", name: "Kyōto" },
                { id: 6496708591780, code: "JP-24", name: "Mie" },
                { id: 6496707936420, code: "JP-04", name: "Miyagi" },
                { id: 6496709279908, code: "JP-45", name: "Miyazaki" },
                { id: 6496708460708, code: "JP-20", name: "Nagano" },
                { id: 6496709181604, code: "JP-42", name: "Nagasaki" },
                { id: 6496708755620, code: "JP-29", name: "Nara" },
                { id: 6496708296868, code: "JP-15", name: "Niigata" },
                { id: 6496709247140, code: "JP-44", name: "Ōita" },
                { id: 6496708886692, code: "JP-33", name: "Okayama" },
                { id: 6496709345444, code: "JP-47", name: "Okinawa" },
                { id: 6496708690084, code: "JP-27", name: "Ōsaka" },
                { id: 6496709148836, code: "JP-41", name: "Saga" },
                { id: 6496708165796, code: "JP-11", name: "Saitama" },
                { id: 6496708624548, code: "JP-25", name: "Shiga" },
                { id: 6496708853924, code: "JP-32", name: "Shimane" },
                { id: 6496708526244, code: "JP-22", name: "Shizuoka" },
                { id: 6496708100260, code: "JP-09", name: "Tochigi" },
                { id: 6496708984996, code: "JP-36", name: "Tokushima" },
                { id: 6496708231332, code: "JP-13", name: "Tōkyō" },
                { id: 6496708821156, code: "JP-31", name: "Tottori" },
                { id: 6496708329636, code: "JP-16", name: "Toyama" },
                { id: 6496708788388, code: "JP-30", name: "Wakayama" },
                { id: 6496708001956, code: "JP-06", name: "Yamagata" },
                { id: 6496708952228, code: "JP-35", name: "Yamaguchi" },
                { id: 6496708427940, code: "JP-19", name: "Yamanashi" }
            ]
        },
        {
            id: 1153689419940,
            code: "JE",
            name: "Jersey",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/je-BmOZ2BCgp0nD.svg",
            currencyCode: "GBP",
            phoneCode: 44,
            provinces: []
        },
        {
            id: 1153688076452,
            code: "JO",
            name: "Jordan",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/jo-0sMGChsBiPK9.svg",
            currencyCode: "",
            phoneCode: 962,
            provinces: []
        },
        {
            id: 1153688109220,
            code: "KZ",
            name: "Kazakhstan",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/kz-BT1OaOdLalrm.svg",
            currencyCode: "KZT",
            phoneCode: 7,
            provinces: []
        },
        {
            id: 1153686503588,
            code: "KE",
            name: "Kenya",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ke-BmHkVwtNfWuG.svg",
            currencyCode: "KES",
            phoneCode: 254,
            provinces: []
        },
        {
            id: 1153691418788,
            code: "KI",
            name: "Kiribati",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ki-BVyzQkTTzaUB.svg",
            currencyCode: "AUD",
            phoneCode: 686,
            provinces: []
        },
        {
            id: 1153689452708,
            code: "XK",
            name: "Kosovo",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/xk-ByMsBiQMCyOo.svg",
            currencyCode: "EUR",
            phoneCode: 383,
            provinces: []
        },
        {
            id: 1153688141988,
            code: "KW",
            name: "Kuwait",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/kw-BO1mln6214L7.svg",
            currencyCode: "",
            phoneCode: 965,
            provinces: [
                { id: 12648672985252, code: "KW-AH", name: "Al Ahmadi" },
                { id: 12648673018020, code: "KW-KU", name: "Al Asimah" },
                { id: 12648673050788, code: "KW-FA", name: "Al Farwaniyah" },
                { id: 12648673083556, code: "KW-JA", name: "Al Jahra" },
                { id: 12648673116324, code: "KW-HA", name: "Hawalli" },
                { id: 12648673149092, code: "KW-MU", name: "Mubarak Al-Kabeer" }
            ]
        },
        {
            id: 1153688174756,
            code: "KG",
            name: "Kyrgyzstan",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/kg-CBH-JE5xBb-X.svg",
            currencyCode: "KGS",
            phoneCode: 996,
            provinces: []
        },
        {
            id: 1153688207524,
            code: "LA",
            name: "Lao People's Democratic Republic",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/la-rnjudWq-ueyL.svg",
            currencyCode: "LAK",
            phoneCode: 856,
            provinces: []
        },
        {
            id: 1153689485476,
            code: "LV",
            name: "Latvia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/lv-2Vvuo0hfbac4.svg",
            currencyCode: "EUR",
            phoneCode: 371,
            provinces: []
        },
        {
            id: 1153688240292,
            code: "LB",
            name: "Lebanon",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/lb-CxZCHG_M8Eke.svg",
            currencyCode: "LBP",
            phoneCode: 961,
            provinces: []
        },
        {
            id: 1153686536356,
            code: "LS",
            name: "Lesotho",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ls-ElcnZbJL0rDq.svg",
            currencyCode: "LSL",
            phoneCode: 266,
            provinces: []
        },
        {
            id: 1153686569124,
            code: "LR",
            name: "Liberia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/lr-BkESDYVM2Bwl.svg",
            currencyCode: "LRD",
            phoneCode: 231,
            provinces: []
        },
        {
            id: 1153686601892,
            code: "LY",
            name: "Libyan Arab Jamahiriya",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ly-AWgU6oFQ6tRT.svg",
            currencyCode: "",
            phoneCode: 218,
            provinces: []
        },
        {
            id: 1153689518244,
            code: "LI",
            name: "Liechtenstein",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/li-DPgm9e3bOpIm.svg",
            currencyCode: "CHF",
            phoneCode: 423,
            provinces: []
        },
        {
            id: 1153689551012,
            code: "LT",
            name: "Lithuania",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/lt-B8g37z5VHFpO.svg",
            currencyCode: "EUR",
            phoneCode: 370,
            provinces: []
        },
        {
            id: 1153689583780,
            code: "LU",
            name: "Luxembourg",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/lu-CbU5hMlUhTnC.svg",
            currencyCode: "EUR",
            phoneCode: 352,
            provinces: []
        },
        {
            id: 1153688273060,
            code: "MO",
            name: "Macao",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/mo-BP56VUvAlto2.svg",
            currencyCode: "MOP",
            phoneCode: 853,
            provinces: []
        },
        {
            id: 1153686634660,
            code: "MG",
            name: "Madagascar",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/mg-CgNyvXjocM-P.svg",
            currencyCode: "",
            phoneCode: 261,
            provinces: []
        },
        {
            id: 1153686667428,
            code: "MW",
            name: "Malawi",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/mw-vX5_t2b4rOdv.svg",
            currencyCode: "MWK",
            phoneCode: 265,
            provinces: []
        },
        {
            id: 626906169508,
            code: "MY",
            name: "Malaysia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/my-z_EhColiAS7U.svg",
            currencyCode: "MYR",
            phoneCode: 60,
            provinces: [
                { id: 6496709935268, code: "JHR", name: "Johor" },
                { id: 6496709968036, code: "KDH", name: "Kedah" },
                { id: 6496710000804, code: "KTN", name: "Kelantan" },
                { id: 6496710033572, code: "KUL", name: "Kuala Lumpur" },
                { id: 6496710066340, code: "LBN", name: "Labuan" },
                { id: 6496710099108, code: "MLK", name: "Melaka" },
                { id: 6496710131876, code: "NSN", name: "Negeri Sembilan" },
                { id: 6496710164644, code: "PHG", name: "Pahang" },
                { id: 6496710197412, code: "PNG", name: "Penang" },
                { id: 6496710230180, code: "PRK", name: "Perak" },
                { id: 6496710262948, code: "PLS", name: "Perlis" },
                { id: 6496710295716, code: "PJY", name: "Putrajaya" },
                { id: 6496710328484, code: "SBH", name: "Sabah" },
                { id: 6496710361252, code: "SWK", name: "Sarawak" },
                { id: 6496710394020, code: "SGR", name: "Selangor" },
                { id: 6496710426788, code: "TRG", name: "Terengganu" }
            ]
        },
        {
            id: 1153688305828,
            code: "MV",
            name: "Maldives",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/mv-Dyyvar1ZL6gR.svg",
            currencyCode: "MVR",
            phoneCode: 960,
            provinces: []
        },
        {
            id: 1153686700196,
            code: "ML",
            name: "Mali",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ml-CRVxghb_RHyf.svg",
            currencyCode: "XOF",
            phoneCode: 223,
            provinces: []
        },
        {
            id: 1153689616548,
            code: "MT",
            name: "Malta",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/mt-OqUS3o7fDGH2.svg",
            currencyCode: "EUR",
            phoneCode: 356,
            provinces: []
        },
        {
            id: 1153690796196,
            code: "MQ",
            name: "Martinique",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/mq-C2VGCknWaEDs.svg",
            currencyCode: "EUR",
            phoneCode: 596,
            provinces: []
        },
        {
            id: 1153686732964,
            code: "MR",
            name: "Mauritania",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/mr-CzLbEa4l0Yph.svg",
            currencyCode: "",
            phoneCode: 222,
            provinces: []
        },
        {
            id: 1153686765732,
            code: "MU",
            name: "Mauritius",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/mu-CPnlWc5P8VzW.svg",
            currencyCode: "MUR",
            phoneCode: 230,
            provinces: []
        },
        {
            id: 1153686798500,
            code: "YT",
            name: "Mayotte",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bl-CtQQKLp3ZzwW.svg",
            currencyCode: "EUR",
            phoneCode: 262,
            provinces: []
        },
        {
            id: 1153690828964,
            code: "MX",
            name: "Mexico",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/mx-Dwc05L0IlS4k.svg",
            currencyCode: "MXN",
            phoneCode: 52,
            provinces: [
                { id: 12648683896996, code: "AGS", name: "Aguascalientes" },
                { id: 12648683929764, code: "BC", name: "Baja California" },
                { id: 12648683962532, code: "BCS", name: "Baja California Sur" },
                { id: 12648683995300, code: "CAMP", name: "Campeche" },
                { id: 12648684028068, code: "CHIS", name: "Chiapas" },
                { id: 12648684060836, code: "CHIH", name: "Chihuahua" },
                { id: 12648684093604, code: "DF", name: "Ciudad de México" },
                { id: 12648684126372, code: "COAH", name: "Coahuila" },
                { id: 12648684159140, code: "COL", name: "Colima" },
                { id: 12648684191908, code: "DGO", name: "Durango" },
                { id: 12648684224676, code: "GTO", name: "Guanajuato" },
                { id: 12648684257444, code: "GRO", name: "Guerrero" },
                { id: 12648684290212, code: "HGO", name: "Hidalgo" },
                { id: 12648684322980, code: "JAL", name: "Jalisco" },
                { id: 12648684355748, code: "MEX", name: "México" },
                { id: 12648684388516, code: "MICH", name: "Michoacán" },
                { id: 12648684421284, code: "MOR", name: "Morelos" },
                { id: 12648684454052, code: "NAY", name: "Nayarit" },
                { id: 12648684486820, code: "NL", name: "Nuevo León" },
                { id: 12648684519588, code: "OAX", name: "Oaxaca" },
                { id: 12648684552356, code: "PUE", name: "Puebla" },
                { id: 12648684585124, code: "QRO", name: "Querétaro" },
                { id: 12648684617892, code: "Q ROO", name: "Quintana Roo" },
                { id: 12648684650660, code: "SLP", name: "San Luis Potosí" },
                { id: 12648684683428, code: "SIN", name: "Sinaloa" },
                { id: 12648684716196, code: "SON", name: "Sonora" },
                { id: 12648684748964, code: "TAB", name: "Tabasco" },
                { id: 12648684781732, code: "TAMPS", name: "Tamaulipas" },
                { id: 12648684814500, code: "TLAX", name: "Tlaxcala" },
                { id: 12648684847268, code: "VER", name: "Veracruz" },
                { id: 12648684880036, code: "YUC", name: "Yucatán" },
                { id: 12648684912804, code: "ZAC", name: "Zacatecas" }
            ]
        },
        {
            id: 1153689649316,
            code: "MD",
            name: "Moldova, Republic of",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/md-gJu3QvjKv0u9.svg",
            currencyCode: "MDL",
            phoneCode: 373,
            provinces: []
        },
        {
            id: 1153689682084,
            code: "MC",
            name: "Monaco",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/mc-HF-hWSt2QotU.svg",
            currencyCode: "EUR",
            phoneCode: 377,
            provinces: []
        },
        {
            id: 1153688338596,
            code: "MN",
            name: "Mongolia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/mn-DXeA6lf_IqGs.svg",
            currencyCode: "MNT",
            phoneCode: 976,
            provinces: []
        },
        {
            id: 1153689714852,
            code: "ME",
            name: "Montenegro",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/me-9tBK-mKT__M3.svg",
            currencyCode: "EUR",
            phoneCode: 382,
            provinces: []
        },
        {
            id: 1153690861732,
            code: "MS",
            name: "Montserrat",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ms-DQq3DqCJn3y9.svg",
            currencyCode: "XCD",
            phoneCode: 1664,
            provinces: []
        },
        {
            id: 1153686831268,
            code: "MA",
            name: "Morocco",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ma-C1dL7CTP90LN.svg",
            currencyCode: "MAD",
            phoneCode: 212,
            provinces: []
        },
        {
            id: 1153686864036,
            code: "MZ",
            name: "Mozambique",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/mz-4fXHR3rLS8Kw.svg",
            currencyCode: "MZN",
            phoneCode: 258,
            provinces: []
        },
        {
            id: 1153688371364,
            code: "MM",
            name: "Myanmar (Burma)",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/mm-Dx3NCp5622Fx.svg",
            currencyCode: "MMK",
            phoneCode: 95,
            provinces: []
        },
        {
            id: 1153686896804,
            code: "NA",
            name: "Namibia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/na-CA_9RoASc1BM.svg",
            currencyCode: "NAD",
            phoneCode: 264,
            provinces: []
        },
        {
            id: 1153691451556,
            code: "NR",
            name: "Nauru",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/nr-CHC0Wbp_WwAW.svg",
            currencyCode: "AUD",
            phoneCode: 674,
            provinces: []
        },
        {
            id: 1153688404132,
            code: "NP",
            name: "Nepal",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/np-DkF1GtKge3kE.svg",
            currencyCode: "NPR",
            phoneCode: 977,
            provinces: []
        },
        {
            id: 626906202276,
            code: "NL",
            name: "Netherlands",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/nl-BElUYFU_o-Oc.svg",
            currencyCode: "EUR",
            phoneCode: 31,
            provinces: []
        },
        {
            id: 1153691484324,
            code: "NC",
            name: "New Caledonia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bl-CtQQKLp3ZzwW.svg",
            currencyCode: "XPF",
            phoneCode: 687,
            provinces: []
        },
        {
            id: 626906267812,
            code: "NZ",
            name: "New Zealand",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/nz-CDyIOIlN26V_.svg",
            currencyCode: "NZD",
            phoneCode: 64,
            provinces: [
                { id: 6496710459556, code: "AUK", name: "Auckland" },
                { id: 6496710492324, code: "BOP", name: "Bay of Plenty" },
                { id: 6496710525092, code: "CAN", name: "Canterbury" },
                { id: 6496710557860, code: "CIT", name: "Chatham Islands" },
                { id: 6496710590628, code: "GIS", name: "Gisborne" },
                { id: 6496710623396, code: "HKB", name: "Hawke's Bay" },
                { id: 6496710656164, code: "MWT", name: "Manawatu-Wanganui" },
                { id: 6496710688932, code: "MBH", name: "Marlborough" },
                { id: 6496710721700, code: "NSN", name: "Nelson" },
                { id: 6496710754468, code: "NTL", name: "Northland" },
                { id: 6496710787236, code: "OTA", name: "Otago" },
                { id: 6496710820004, code: "STL", name: "Southland" },
                { id: 6496710852772, code: "TKI", name: "Taranaki" },
                { id: 6496710885540, code: "TAS", name: "Tasman" },
                { id: 6496710918308, code: "WKO", name: "Waikato" },
                { id: 6496710951076, code: "WGN", name: "Wellington" },
                { id: 6496710983844, code: "WTC", name: "West Coast" }
            ]
        },
        {
            id: 1153690894500,
            code: "NI",
            name: "Nicaragua",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ni-DEDmWwU_ULET.svg",
            currencyCode: "NIO",
            phoneCode: 505,
            provinces: []
        },
        {
            id: 1153686929572,
            code: "NE",
            name: "Niger",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ne-DFfTuq-3AR-F.svg",
            currencyCode: "XOF",
            phoneCode: 227,
            provinces: []
        },
        {
            id: 1153686962340,
            code: "NG",
            name: "Nigeria",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ng-CeFSaW46NMNJ.svg",
            currencyCode: "NGN",
            phoneCode: 234,
            provinces: [
                { id: 12648668135588, code: "AB", name: "Abia" },
                { id: 12648668168356, code: "FC", name: "Abuja Federal Capital Territory" },
                { id: 12648668201124, code: "AD", name: "Adamawa" },
                { id: 12648668233892, code: "AK", name: "Akwa Ibom" },
                { id: 12648668266660, code: "AN", name: "Anambra" },
                { id: 12648668299428, code: "BA", name: "Bauchi" },
                { id: 12648668332196, code: "BY", name: "Bayelsa" },
                { id: 12648668364964, code: "BE", name: "Benue" },
                { id: 12648668397732, code: "BO", name: "Borno" },
                { id: 12648668430500, code: "CR", name: "Cross River" },
                { id: 12648668463268, code: "DE", name: "Delta" },
                { id: 12648668496036, code: "EB", name: "Ebonyi" },
                { id: 12648668528804, code: "ED", name: "Edo" },
                { id: 12648668561572, code: "EK", name: "Ekiti" },
                { id: 12648668594340, code: "EN", name: "Enugu" },
                { id: 12648668627108, code: "GO", name: "Gombe" },
                { id: 12648668659876, code: "IM", name: "Imo" },
                { id: 12648668692644, code: "JI", name: "Jigawa" },
                { id: 12648668725412, code: "KD", name: "Kaduna" },
                { id: 12648668758180, code: "KN", name: "Kano" },
                { id: 12648668790948, code: "KT", name: "Katsina" },
                { id: 12648668823716, code: "KE", name: "Kebbi" },
                { id: 12648668856484, code: "KO", name: "Kogi" },
                { id: 12648668889252, code: "KW", name: "Kwara" },
                { id: 12648668922020, code: "LA", name: "Lagos" },
                { id: 12648668954788, code: "NA", name: "Nasarawa" },
                { id: 12648668987556, code: "NI", name: "Niger" },
                { id: 12648669020324, code: "OG", name: "Ogun" },
                { id: 12648669053092, code: "ON", name: "Ondo" },
                { id: 12648669085860, code: "OS", name: "Osun" },
                { id: 12648669118628, code: "OY", name: "Oyo" },
                { id: 12648669151396, code: "PL", name: "Plateau" },
                { id: 12648669184164, code: "RI", name: "Rivers" },
                { id: 12648669216932, code: "SO", name: "Sokoto" },
                { id: 12648669249700, code: "TA", name: "Taraba" },
                { id: 12648669282468, code: "YO", name: "Yobe" },
                { id: 12648669315236, code: "ZA", name: "Zamfara" }
            ]
        },
        {
            id: 1153691517092,
            code: "NU",
            name: "Niue",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/nu-CE2Lz4I6zIll.svg",
            currencyCode: "NZD",
            phoneCode: 683,
            provinces: []
        },
        {
            id: 1153691549860,
            code: "NF",
            name: "Norfolk Island",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/nf-D4FcPRNmDZFa.svg",
            currencyCode: "AUD",
            phoneCode: 672,
            provinces: []
        },
        {
            id: 1153689747620,
            code: "MK",
            name: "North Macedonia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/mk-C0VgXr7aV74p.svg",
            currencyCode: "MKD",
            phoneCode: 389,
            provinces: []
        },
        {
            id: 626906235044,
            code: "NO",
            name: "Norway",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/no-BeK60oyVXJun.svg",
            currencyCode: "NOK",
            phoneCode: 47,
            provinces: []
        },
        {
            id: 1153688436900,
            code: "OM",
            name: "Oman",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/om-C4vZ-U9JJYUa.svg",
            currencyCode: "",
            phoneCode: 968,
            provinces: []
        },
        {
            id: 1153688469668,
            code: "PK",
            name: "Pakistan",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/pk-C6GKfae7SBqL.svg",
            currencyCode: "PKR",
            phoneCode: 92,
            provinces: []
        },
        {
            id: 1153688502436,
            code: "PS",
            name: "Palestinian Territory, Occupied",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ps-KD9ygNdeZGN0.svg",
            currencyCode: "ILS",
            phoneCode: 970,
            provinces: []
        },
        {
            id: 1153690927268,
            code: "PA",
            name: "Panama",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/pa-DPtQXZxtY4SM.svg",
            currencyCode: "USD",
            phoneCode: 507,
            provinces: [
                { id: 12648684945572, code: "PA-1", name: "Bocas del Toro" },
                { id: 12648684978340, code: "PA-4", name: "Chiriquí" },
                { id: 12648685011108, code: "PA-2", name: "Coclé" },
                { id: 12648685043876, code: "PA-3", name: "Colón" },
                { id: 12648685076644, code: "PA-5", name: "Darién" },
                { id: 12648685109412, code: "PA-EM", name: "Emberá" },
                { id: 12648685142180, code: "PA-6", name: "Herrera" },
                { id: 12648685174948, code: "PA-KY", name: "Kuna Yala" },
                { id: 12648685207716, code: "PA-7", name: "Los Santos" },
                { id: 12648685240484, code: "PA-NB", name: "Ngöbe-Buglé" },
                { id: 12648685273252, code: "PA-8", name: "Panamá" },
                { id: 12648685306020, code: "PA-10", name: "Panamá Oeste" },
                { id: 12648685338788, code: "PA-9", name: "Veraguas" }
            ]
        },
        {
            id: 1153691582628,
            code: "PG",
            name: "Papua New Guinea",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/pg-CJFLyGg7M3vB.svg",
            currencyCode: "PGK",
            phoneCode: 675,
            provinces: []
        },
        {
            id: 1153692205220,
            code: "PY",
            name: "Paraguay",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/py-BQeX8-Npw4mU.svg",
            currencyCode: "PYG",
            phoneCode: 595,
            provinces: []
        },
        {
            id: 1153692237988,
            code: "PE",
            name: "Peru",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/pe-piYHFy6VHHRJ.svg",
            currencyCode: "PEN",
            phoneCode: 51,
            provinces: [
                { id: 12648688648356, code: "PE-AMA", name: "Amazonas" },
                { id: 12648688681124, code: "PE-ANC", name: "Áncash" },
                { id: 12648688713892, code: "PE-APU", name: "Apurímac" },
                { id: 12648688746660, code: "PE-ARE", name: "Arequipa" },
                { id: 12648688779428, code: "PE-AYA", name: "Ayacucho" },
                { id: 12648688812196, code: "PE-CAJ", name: "Cajamarca" },
                { id: 12648688844964, code: "PE-CAL", name: "Callao" },
                { id: 12648688877732, code: "PE-CUS", name: "Cuzco" },
                { id: 12648688910500, code: "PE-HUV", name: "Huancavelica" },
                { id: 12648688943268, code: "PE-HUC", name: "Huánuco" },
                { id: 12648688976036, code: "PE-ICA", name: "Ica" },
                { id: 12648689008804, code: "PE-JUN", name: "Junín" },
                { id: 12648689041572, code: "PE-LAL", name: "La Libertad" },
                { id: 12648689074340, code: "PE-LAM", name: "Lambayeque" },
                { id: 12648689107108, code: "PE-LIM", name: "Lima (departamento)" },
                { id: 12648689139876, code: "PE-LMA", name: "Lima (provincia)" },
                { id: 12648689172644, code: "PE-LOR", name: "Loreto" },
                { id: 12648689205412, code: "PE-MDD", name: "Madre de Dios" },
                { id: 12648689238180, code: "PE-MOQ", name: "Moquegua" },
                { id: 12648689270948, code: "PE-PAS", name: "Pasco" },
                { id: 12648689303716, code: "PE-PIU", name: "Piura" },
                { id: 12648689336484, code: "PE-PUN", name: "Puno" },
                { id: 12648689369252, code: "PE-SAM", name: "San Martín" },
                { id: 12648689402020, code: "PE-TAC", name: "Tacna" },
                { id: 12648689434788, code: "PE-TUM", name: "Tumbes" },
                { id: 12648689467556, code: "PE-UCA", name: "Ucayali" }
            ]
        },
        {
            id: 1153688535204,
            code: "PH",
            name: "Philippines",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ph-vgKMQDRt8t-c.svg",
            currencyCode: "PHP",
            phoneCode: 63,
            provinces: [
                { id: 12648673181860, code: "PH-ABR", name: "Abra" },
                { id: 12648673214628, code: "PH-AGN", name: "Agusan del Norte" },
                { id: 12648673247396, code: "PH-AGS", name: "Agusan del Sur" },
                { id: 12648673280164, code: "PH-AKL", name: "Aklan" },
                { id: 12648673312932, code: "PH-ALB", name: "Albay" },
                { id: 12648673345700, code: "PH-ANT", name: "Antique" },
                { id: 12648673378468, code: "PH-APA", name: "Apayao" },
                { id: 12648673411236, code: "PH-AUR", name: "Aurora" },
                { id: 12648673444004, code: "PH-BAS", name: "Basilan" },
                { id: 12648673476772, code: "PH-BAN", name: "Bataan" },
                { id: 12648673509540, code: "PH-BTN", name: "Batanes" },
                { id: 12648673542308, code: "PH-BTG", name: "Batangas" },
                { id: 12648673575076, code: "PH-BEN", name: "Benguet" },
                { id: 12648673607844, code: "PH-BIL", name: "Biliran" },
                { id: 12648673640612, code: "PH-BOH", name: "Bohol" },
                { id: 12648673673380, code: "PH-BUK", name: "Bukidnon" },
                { id: 12648673706148, code: "PH-BUL", name: "Bulacan" },
                { id: 12648673738916, code: "PH-CAG", name: "Cagayan" },
                { id: 12648673771684, code: "PH-CAN", name: "Camarines Norte" },
                { id: 12648673804452, code: "PH-CAS", name: "Camarines Sur" },
                { id: 12648673837220, code: "PH-CAM", name: "Camiguin" },
                { id: 12648673869988, code: "PH-CAP", name: "Capiz" },
                { id: 12648673902756, code: "PH-CAT", name: "Catanduanes" },
                { id: 12648673935524, code: "PH-CAV", name: "Cavite" },
                { id: 12648673968292, code: "PH-CEB", name: "Cebu" },
                { id: 12648674001060, code: "PH-NCO", name: "Cotabato" },
                { id: 12648674099364, code: "PH-COM", name: "Davao de Oro" },
                { id: 12648674132132, code: "PH-DAV", name: "Davao del Norte" },
                { id: 12648674164900, code: "PH-DAS", name: "Davao del Sur" },
                { id: 12648674033828, code: "PH-DVO", name: "Davao Occidental" },
                { id: 12648674066596, code: "PH-DAO", name: "Davao Oriental" },
                { id: 12648674197668, code: "PH-DIN", name: "Dinagat Islands" },
                { id: 12648674230436, code: "PH-EAS", name: "Eastern Samar" },
                { id: 12648674263204, code: "PH-GUI", name: "Guimaras" },
                { id: 12648674295972, code: "PH-IFU", name: "Ifugao" },
                { id: 12648674328740, code: "PH-ILN", name: "Ilocos Norte" },
                { id: 12648674361508, code: "PH-ILS", name: "Ilocos Sur" },
                { id: 12648674394276, code: "PH-ILI", name: "Iloilo" },
                { id: 12648674427044, code: "PH-ISA", name: "Isabela" },
                { id: 12648674459812, code: "PH-KAL", name: "Kalinga" },
                { id: 12648674492580, code: "PH-LUN", name: "La Union" },
                { id: 12648674525348, code: "PH-LAG", name: "Laguna" },
                { id: 12648674558116, code: "PH-LAN", name: "Lanao del Norte" },
                { id: 12648674590884, code: "PH-LAS", name: "Lanao del Sur" },
                { id: 12648674623652, code: "PH-LEY", name: "Leyte" },
                { id: 12648674656420, code: "PH-MAG", name: "Maguindanao" },
                { id: 12648674689188, code: "PH-MAD", name: "Marinduque" },
                { id: 12648674721956, code: "PH-MAS", name: "Masbate" },
                { id: 12648674754724, code: "PH-00", name: "Metro Manila" },
                { id: 12648674787492, code: "PH-MSC", name: "Misamis Occidental" },
                { id: 12648674820260, code: "PH-MSR", name: "Misamis Oriental" },
                { id: 12648674853028, code: "PH-MOU", name: "Mountain Province" },
                { id: 12648674885796, code: "PH-NEC", name: "Negros Occidental" },
                { id: 12648674918564, code: "PH-NER", name: "Negros Oriental" },
                { id: 12648674951332, code: "PH-NSA", name: "Northern Samar" },
                { id: 12648674984100, code: "PH-NUE", name: "Nueva Ecija" },
                { id: 12648675016868, code: "PH-NUV", name: "Nueva Vizcaya" },
                { id: 12648675049636, code: "PH-MDC", name: "Occidental Mindoro" },
                { id: 12648675082404, code: "PH-MDR", name: "Oriental Mindoro" },
                { id: 12648675115172, code: "PH-PLW", name: "Palawan" },
                { id: 12648675147940, code: "PH-PAM", name: "Pampanga" },
                { id: 12648675180708, code: "PH-PAN", name: "Pangasinan" },
                { id: 12648675213476, code: "PH-QUE", name: "Quezon" },
                { id: 12648675246244, code: "PH-QUI", name: "Quirino" },
                { id: 12648675279012, code: "PH-RIZ", name: "Rizal" },
                { id: 12648675311780, code: "PH-ROM", name: "Romblon" },
                { id: 12648675344548, code: "PH-WSA", name: "Samar" },
                { id: 12648675377316, code: "PH-SAR", name: "Sarangani" },
                { id: 12648675410084, code: "PH-SIG", name: "Siquijor" },
                { id: 12648675442852, code: "PH-SOR", name: "Sorsogon" },
                { id: 12648675475620, code: "PH-SCO", name: "South Cotabato" },
                { id: 12648675508388, code: "PH-SLE", name: "Southern Leyte" },
                { id: 12648675541156, code: "PH-SUK", name: "Sultan Kudarat" },
                { id: 12648675573924, code: "PH-SLU", name: "Sulu" },
                { id: 12648675606692, code: "PH-SUN", name: "Surigao del Norte" },
                { id: 12648675639460, code: "PH-SUR", name: "Surigao del Sur" },
                { id: 12648675672228, code: "PH-TAR", name: "Tarlac" },
                { id: 12648675704996, code: "PH-TAW", name: "Tawi-Tawi" },
                { id: 12648675737764, code: "PH-ZMB", name: "Zambales" },
                { id: 12648675803300, code: "PH-ZAN", name: "Zamboanga del Norte" },
                { id: 12648675836068, code: "PH-ZAS", name: "Zamboanga del Sur" },
                { id: 12648675770532, code: "PH-ZSI", name: "Zamboanga Sibugay" }
            ]
        },
        {
            id: 1153691615396,
            code: "PN",
            name: "Pitcairn",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/pn-hZZabwZGNFHQ.svg",
            currencyCode: "NZD",
            phoneCode: 64,
            provinces: []
        },
        {
            id: 626906300580,
            code: "PL",
            name: "Poland",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/pl-BSwUsS6To8z0.svg",
            currencyCode: "PLN",
            phoneCode: 48,
            provinces: []
        },
        {
            id: 626906333348,
            code: "PT",
            name: "Portugal",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/pt-CauU9mq_6CmM.svg",
            currencyCode: "EUR",
            phoneCode: 351,
            provinces: [
                { id: 6496711016612, code: "PT-20", name: "Açores" },
                { id: 6496711049380, code: "PT-01", name: "Aveiro" },
                { id: 6496711082148, code: "PT-02", name: "Beja" },
                { id: 6496711114916, code: "PT-03", name: "Braga" },
                { id: 6496711147684, code: "PT-04", name: "Bragança" },
                { id: 6496711180452, code: "PT-05", name: "Castelo Branco" },
                { id: 6496711213220, code: "PT-06", name: "Coimbra" },
                { id: 6496711245988, code: "PT-07", name: "Évora" },
                { id: 6496711278756, code: "PT-08", name: "Faro" },
                { id: 6496711311524, code: "PT-09", name: "Guarda" },
                { id: 6496711344292, code: "PT-10", name: "Leiria" },
                { id: 6496711377060, code: "PT-11", name: "Lisboa" },
                { id: 6496711409828, code: "PT-30", name: "Madeira" },
                { id: 6496711442596, code: "PT-12", name: "Portalegre" },
                { id: 6496711475364, code: "PT-13", name: "Porto" },
                { id: 6496711508132, code: "PT-14", name: "Santarém" },
                { id: 6496711540900, code: "PT-15", name: "Setúbal" },
                { id: 6496711573668, code: "PT-16", name: "Viana do Castelo" },
                { id: 6496711606436, code: "PT-17", name: "Vila Real" },
                { id: 6496711639204, code: "PT-18", name: "Viseu" }
            ]
        },
        {
            id: 1153688567972,
            code: "QA",
            name: "Qatar",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/qa-Cqom2Li1Tgvm.svg",
            currencyCode: "QAR",
            phoneCode: 974,
            provinces: []
        },
        {
            id: 1153685848228,
            code: "CM",
            name: "Republic of Cameroon",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/cm-C3RxYTaSwrhL.svg",
            currencyCode: "XAF",
            phoneCode: 237,
            provinces: []
        },
        {
            id: 1153686995108,
            code: "RE",
            name: "Reunion",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bl-CtQQKLp3ZzwW.svg",
            currencyCode: "EUR",
            phoneCode: 262,
            provinces: []
        },
        {
            id: 1153689780388,
            code: "RO",
            name: "Romania",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ro-C4aDxciVwXc1.svg",
            currencyCode: "RON",
            phoneCode: 40,
            provinces: [
                { id: 12648678424740, code: "AB", name: "Alba" },
                { id: 12648678457508, code: "AR", name: "Arad" },
                { id: 12648678490276, code: "AG", name: "Argeș" },
                { id: 12648678523044, code: "BC", name: "Bacău" },
                { id: 12648678555812, code: "BH", name: "Bihor" },
                { id: 12648678588580, code: "BN", name: "Bistrița-Năsăud" },
                { id: 12648678621348, code: "BT", name: "Botoșani" },
                { id: 12648678654116, code: "BR", name: "Brăila" },
                { id: 12648678686884, code: "BV", name: "Brașov" },
                { id: 12648678719652, code: "B", name: "București" },
                { id: 12648678752420, code: "BZ", name: "Buzău" },
                { id: 12648678916260, code: "CL", name: "Călărași" },
                { id: 12648678785188, code: "CS", name: "Caraș-Severin" },
                { id: 12648678817956, code: "CJ", name: "Cluj" },
                { id: 12648678850724, code: "CT", name: "Constanța" },
                { id: 12648678883492, code: "CV", name: "Covasna" },
                { id: 12648678981796, code: "DB", name: "Dâmbovița" },
                { id: 12648678949028, code: "DJ", name: "Dolj" },
                { id: 12648679014564, code: "GL", name: "Galați" },
                { id: 12648679047332, code: "GR", name: "Giurgiu" },
                { id: 12648679080100, code: "GJ", name: "Gorj" },
                { id: 12648679112868, code: "HR", name: "Harghita" },
                { id: 12648679145636, code: "HD", name: "Hunedoara" },
                { id: 12648679178404, code: "IL", name: "Ialomița" },
                { id: 12648679211172, code: "IS", name: "Iași" },
                { id: 12648679243940, code: "IF", name: "Ilfov" },
                { id: 12648679276708, code: "MM", name: "Maramureș" },
                { id: 12648679309476, code: "MH", name: "Mehedinți" },
                { id: 12648679342244, code: "MS", name: "Mureș" },
                { id: 12648679375012, code: "NT", name: "Neamț" },
                { id: 12648679407780, code: "OT", name: "Olt" },
                { id: 12648679440548, code: "PH", name: "Prahova" },
                { id: 12648679473316, code: "SJ", name: "Sălaj" },
                { id: 12648679506084, code: "SM", name: "Satu Mare" },
                { id: 12648679538852, code: "SB", name: "Sibiu" },
                { id: 12648679571620, code: "SV", name: "Suceava" },
                { id: 12648679604388, code: "TR", name: "Teleorman" },
                { id: 12648679637156, code: "TM", name: "Timiș" },
                { id: 12648679669924, code: "TL", name: "Tulcea" },
                { id: 12648679702692, code: "VL", name: "Vâlcea" },
                { id: 12648679735460, code: "VS", name: "Vaslui" },
                { id: 12648679768228, code: "VN", name: "Vrancea" }
            ]
        },
        {
            id: 1153689813156,
            code: "RU",
            name: "Russia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ru-DR6aj0J9lf8x.svg",
            currencyCode: "RUB",
            phoneCode: 7,
            provinces: [
                { id: 12648679800996, code: "ALT", name: "Altai Krai" },
                { id: 12648679833764, code: "AL", name: "Altai Republic" },
                { id: 12648679866532, code: "AMU", name: "Amur Oblast" },
                { id: 12648679899300, code: "ARK", name: "Arkhangelsk Oblast" },
                { id: 12648679932068, code: "AST", name: "Astrakhan Oblast" },
                { id: 12648679964836, code: "BEL", name: "Belgorod Oblast" },
                { id: 12648679997604, code: "BRY", name: "Bryansk Oblast" },
                { id: 12648680030372, code: "CE", name: "Chechen Republic" },
                { id: 12648680063140, code: "CHE", name: "Chelyabinsk Oblast" },
                { id: 12648680095908, code: "CHU", name: "Chukotka Autonomous Okrug" },
                { id: 12648680128676, code: "CU", name: "Chuvash Republic" },
                { id: 12648680161444, code: "IRK", name: "Irkutsk Oblast" },
                { id: 12648680194212, code: "IVA", name: "Ivanovo Oblast" },
                { id: 12648680226980, code: "YEV", name: "Jewish Autonomous Oblast" },
                { id: 12648680259748, code: "KB", name: "Kabardino-Balkarian Republic" },
                { id: 12648680292516, code: "KGD", name: "Kaliningrad Oblast" },
                { id: 12648680325284, code: "KLU", name: "Kaluga Oblast" },
                { id: 12648680358052, code: "KAM", name: "Kamchatka Krai" },
                { id: 12648680390820, code: "KC", name: "Karachay–Cherkess Republic" },
                { id: 12648680423588, code: "KEM", name: "Kemerovo Oblast" },
                { id: 12648680456356, code: "KHA", name: "Khabarovsk Krai" },
                { id: 12648680489124, code: "KHM", name: "Khanty-Mansi Autonomous Okrug" },
                { id: 12648680521892, code: "KIR", name: "Kirov Oblast" },
                { id: 12648680554660, code: "KO", name: "Komi Republic" },
                { id: 12648680587428, code: "KOS", name: "Kostroma Oblast" },
                { id: 12648680620196, code: "KDA", name: "Krasnodar Krai" },
                { id: 12648680652964, code: "KYA", name: "Krasnoyarsk Krai" },
                { id: 12648680685732, code: "KGN", name: "Kurgan Oblast" },
                { id: 12648680718500, code: "KRS", name: "Kursk Oblast" },
                { id: 12648680751268, code: "LEN", name: "Leningrad Oblast" },
                { id: 12648680784036, code: "LIP", name: "Lipetsk Oblast" },
                { id: 12648680816804, code: "MAG", name: "Magadan Oblast" },
                { id: 12648680849572, code: "ME", name: "Mari El Republic" },
                { id: 12648680882340, code: "MOW", name: "Moscow" },
                { id: 12648680915108, code: "MOS", name: "Moscow Oblast" },
                { id: 12648680947876, code: "MUR", name: "Murmansk Oblast" },
                { id: 12648680980644, code: "NIZ", name: "Nizhny Novgorod Oblast" },
                { id: 12648681013412, code: "NGR", name: "Novgorod Oblast" },
                { id: 12648681046180, code: "NVS", name: "Novosibirsk Oblast" },
                { id: 12648681078948, code: "OMS", name: "Omsk Oblast" },
                { id: 12648681111716, code: "ORE", name: "Orenburg Oblast" },
                { id: 12648681144484, code: "ORL", name: "Oryol Oblast" },
                { id: 12648681177252, code: "PNZ", name: "Penza Oblast" },
                { id: 12648681210020, code: "PER", name: "Perm Krai" },
                { id: 12648681242788, code: "PRI", name: "Primorsky Krai" },
                { id: 12648681275556, code: "PSK", name: "Pskov Oblast" },
                { id: 12648681308324, code: "AD", name: "Republic of Adygeya" },
                { id: 12648681341092, code: "BA", name: "Republic of Bashkortostan" },
                { id: 12648681373860, code: "BU", name: "Republic of Buryatia" },
                { id: 12648681406628, code: "DA", name: "Republic of Dagestan" },
                { id: 12648681439396, code: "IN", name: "Republic of Ingushetia" },
                { id: 12648681472164, code: "KL", name: "Republic of Kalmykia" },
                { id: 12648681504932, code: "KR", name: "Republic of Karelia" },
                { id: 12648681537700, code: "KK", name: "Republic of Khakassia" },
                { id: 12648681570468, code: "MO", name: "Republic of Mordovia" },
                { id: 12648681603236, code: "SE", name: "Republic of North Ossetia–Alania" },
                { id: 12648681636004, code: "TA", name: "Republic of Tatarstan" },
                { id: 12648681668772, code: "ROS", name: "Rostov Oblast" },
                { id: 12648681701540, code: "RYA", name: "Ryazan Oblast" },
                { id: 12648681734308, code: "SPE", name: "Saint Petersburg" },
                { id: 12648681767076, code: "SA", name: "Sakha Republic (Yakutia)" },
                { id: 12648681799844, code: "SAK", name: "Sakhalin Oblast" },
                { id: 12648681832612, code: "SAM", name: "Samara Oblast" },
                { id: 12648681865380, code: "SAR", name: "Saratov Oblast" },
                { id: 12648681898148, code: "SMO", name: "Smolensk Oblast" },
                { id: 12648681930916, code: "STA", name: "Stavropol Krai" },
                { id: 12648681963684, code: "SVE", name: "Sverdlovsk Oblast" },
                { id: 12648681996452, code: "TAM", name: "Tambov Oblast" },
                { id: 12648682029220, code: "TOM", name: "Tomsk Oblast" },
                { id: 12648682061988, code: "TUL", name: "Tula Oblast" },
                { id: 12648682094756, code: "TVE", name: "Tver Oblast" },
                { id: 12648682127524, code: "TYU", name: "Tyumen Oblast" },
                { id: 12648682160292, code: "TY", name: "Tyva Republic" },
                { id: 12648682193060, code: "UD", name: "Udmurtia" },
                { id: 12648682225828, code: "ULY", name: "Ulyanovsk Oblast" },
                { id: 12648682258596, code: "VLA", name: "Vladimir Oblast" },
                { id: 12648682291364, code: "VGG", name: "Volgograd Oblast" },
                { id: 12648682324132, code: "VLG", name: "Vologda Oblast" },
                { id: 12648682356900, code: "VOR", name: "Voronezh Oblast" },
                { id: 12648682389668, code: "YAN", name: "Yamalo-Nenets Autonomous Okrug" },
                { id: 12648682422436, code: "YAR", name: "Yaroslavl Oblast" },
                { id: 12648682455204, code: "ZAB", name: "Zabaykalsky Krai" }
            ]
        },
        {
            id: 1153687027876,
            code: "RW",
            name: "Rwanda",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/rw-BDqSeuFoNbOO.svg",
            currencyCode: "RWF",
            phoneCode: 250,
            provinces: []
        },
        {
            id: 1153690992804,
            code: "BL",
            name: "St. Barthélemy",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bl-CtQQKLp3ZzwW.svg",
            currencyCode: "EUR",
            phoneCode: 590,
            provinces: []
        },
        {
            id: 1153687290020,
            code: "SH",
            name: "St. Helena",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/sh-CFG-OHSs2kWg.svg",
            currencyCode: "SHP",
            phoneCode: 2,
            provinces: []
        },
        {
            id: 1153691025572,
            code: "KN",
            name: "St. Kitts & Nevis",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/kn-BnF1EbktrcBj.svg",
            currencyCode: "XCD",
            phoneCode: 1869,
            provinces: []
        },
        {
            id: 1153691058340,
            code: "LC",
            name: "St. Lucia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/lc-C6-ufBBEyCgU.svg",
            currencyCode: "XCD",
            phoneCode: 1758,
            provinces: []
        },
        {
            id: 1153691091108,
            code: "MF",
            name: "St. Martin",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/fr-CvJDduywicne.svg",
            currencyCode: "EUR",
            phoneCode: 590,
            provinces: []
        },
        {
            id: 1153691123876,
            code: "PM",
            name: "St. Pierre & Miquelon",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/bl-CtQQKLp3ZzwW.svg",
            currencyCode: "EUR",
            phoneCode: 508,
            provinces: []
        },
        {
            id: 1153691648164,
            code: "WS",
            name: "Samoa",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ws-D-fWLSWyGXgD.svg",
            currencyCode: "WST",
            phoneCode: 685,
            provinces: []
        },
        {
            id: 1153689845924,
            code: "SM",
            name: "San Marino",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/sm-CZ7yvRSM4GMs.svg",
            currencyCode: "EUR",
            phoneCode: 378,
            provinces: []
        },
        {
            id: 1153687060644,
            code: "ST",
            name: "São Tomé & Príncipe",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/st-BBCn7U-77l4z.svg",
            currencyCode: "STD",
            phoneCode: 239,
            provinces: []
        },
        {
            id: 1153688600740,
            code: "SA",
            name: "Saudi Arabia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/sa-BffmUi_65BhO.svg",
            currencyCode: "SAR",
            phoneCode: 966,
            provinces: []
        },
        {
            id: 1153687093412,
            code: "SN",
            name: "Senegal",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/sn-ZnaHG9stu86x.svg",
            currencyCode: "XOF",
            phoneCode: 221,
            provinces: []
        },
        {
            id: 1153689878692,
            code: "RS",
            name: "Serbia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/rs-BfZ0DQOMxRDD.svg",
            currencyCode: "RSD",
            phoneCode: 381,
            provinces: []
        },
        {
            id: 1153687126180,
            code: "SC",
            name: "Seychelles",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/sc-SwHozwwg2J_Q.svg",
            currencyCode: "SCR",
            phoneCode: 248,
            provinces: []
        },
        {
            id: 1153687158948,
            code: "SL",
            name: "Sierra Leone",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/sl-DFiNrLnobUlX.svg",
            currencyCode: "SLL",
            phoneCode: 232,
            provinces: []
        },
        {
            id: 626906398884,
            code: "SG",
            name: "Singapore",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/sg-BiKhZrv6VC3K.svg",
            currencyCode: "SGD",
            phoneCode: 65,
            provinces: []
        },
        {
            id: 1153690960036,
            code: "SX",
            name: "Sint Maarten",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/sx-Dq7rz0SyIyQ9.svg",
            currencyCode: "ANG",
            phoneCode: 1721,
            provinces: []
        },
        {
            id: 1153689911460,
            code: "SK",
            name: "Slovakia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/sk-CklkPFGI9_uI.svg",
            currencyCode: "EUR",
            phoneCode: 421,
            provinces: []
        },
        {
            id: 1153689944228,
            code: "SI",
            name: "Slovenia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/si-B7YmLrpfYKU4.svg",
            currencyCode: "EUR",
            phoneCode: 386,
            provinces: []
        },
        {
            id: 1153691680932,
            code: "SB",
            name: "Solomon Islands",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/sb-CVVrg21nUn82.svg",
            currencyCode: "SBD",
            phoneCode: 677,
            provinces: []
        },
        {
            id: 1153687191716,
            code: "SO",
            name: "Somalia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/so-DAFxz84h1Gs_.svg",
            currencyCode: "",
            phoneCode: 252,
            provinces: []
        },
        {
            id: 1153687224484,
            code: "ZA",
            name: "South Africa",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/za-LaAgL4izGH17.svg",
            currencyCode: "ZAR",
            phoneCode: 27,
            provinces: [
                { id: 12648669348004, code: "EC", name: "Eastern Cape" },
                { id: 12648669380772, code: "FS", name: "Free State" },
                { id: 12648669413540, code: "GP", name: "Gauteng" },
                { id: 12648669446308, code: "NL", name: "KwaZulu-Natal" },
                { id: 12648669479076, code: "LP", name: "Limpopo" },
                { id: 12648669511844, code: "MP", name: "Mpumalanga" },
                { id: 12648669544612, code: "NW", name: "North West" },
                { id: 12648669577380, code: "NC", name: "Northern Cape" },
                { id: 12648669610148, code: "WC", name: "Western Cape" }
            ]
        },
        {
            id: 1153692270756,
            code: "GS",
            name: "South Georgia & South Sandwich Islands",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/gs-C1usbzhjhpx5.svg",
            currencyCode: "GBP",
            phoneCode: 500,
            provinces: []
        },
        {
            id: 626906136740,
            code: "KR",
            name: "South Korea",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/kr-Dnmw_cNMqEST.svg",
            currencyCode: "KRW",
            phoneCode: 82,
            provinces: [
                { id: 6496709378212, code: "KR-26", name: "Busan" },
                { id: 6496709410980, code: "KR-43", name: "Chungbuk" },
                { id: 6496709443748, code: "KR-44", name: "Chungnam" },
                { id: 6496709476516, code: "KR-27", name: "Daegu" },
                { id: 6496709509284, code: "KR-30", name: "Daejeon" },
                { id: 6496709542052, code: "KR-42", name: "Gangwon" },
                { id: 6496709574820, code: "KR-29", name: "Gwangju" },
                { id: 6496709607588, code: "KR-47", name: "Gyeongbuk" },
                { id: 6496709640356, code: "KR-41", name: "Gyeonggi" },
                { id: 6496709673124, code: "KR-48", name: "Gyeongnam" },
                { id: 6496709705892, code: "KR-28", name: "Incheon" },
                { id: 6496709738660, code: "KR-49", name: "Jeju" },
                { id: 6496709771428, code: "KR-45", name: "Jeonbuk" },
                { id: 6496709804196, code: "KR-46", name: "Jeonnam" },
                { id: 6496709836964, code: "KR-50", name: "Sejong" },
                { id: 6496709869732, code: "KR-11", name: "Seoul" },
                { id: 6496709902500, code: "KR-31", name: "Ulsan" }
            ]
        },
        {
            id: 1153687257252,
            code: "SS",
            name: "South Sudan",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ss-BNcHmljMHlX1.svg",
            currencyCode: "",
            phoneCode: 211,
            provinces: []
        },
        {
            id: 626905841828,
            code: "ES",
            name: "Spain",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/es-BoXRvdlCIbmz.svg",
            currencyCode: "EUR",
            phoneCode: 34,
            provinces: [
                { id: 6496701415588, code: "C", name: "A Coruña" },
                { id: 6496701448356, code: "VI", name: "Álava" },
                { id: 6496701481124, code: "AB", name: "Albacete" },
                { id: 6496701513892, code: "A", name: "Alicante" },
                { id: 6496701546660, code: "AL", name: "Almería" },
                { id: 6496701579428, code: "O", name: "Asturias" },
                { id: 6496701612196, code: "AV", name: "Ávila" },
                { id: 6496701644964, code: "BA", name: "Badajoz" },
                { id: 6496701677732, code: "PM", name: "Balears" },
                { id: 6496701710500, code: "B", name: "Barcelona" },
                { id: 6496701743268, code: "BU", name: "Burgos" },
                { id: 6496701776036, code: "CC", name: "Cáceres" },
                { id: 6496701808804, code: "CA", name: "Cádiz" },
                { id: 6496701841572, code: "S", name: "Cantabria" },
                { id: 6496701874340, code: "CS", name: "Castellón" },
                { id: 6496701907108, code: "CE", name: "Ceuta" },
                { id: 6496701939876, code: "CR", name: "Ciudad Real" },
                { id: 6496701972644, code: "CO", name: "Córdoba" },
                { id: 6496702005412, code: "CU", name: "Cuenca" },
                { id: 6496702038180, code: "GI", name: "Girona" },
                { id: 6496702070948, code: "GR", name: "Granada" },
                { id: 6496702103716, code: "GU", name: "Guadalajara" },
                { id: 6496702136484, code: "SS", name: "Guipúzcoa" },
                { id: 6496702169252, code: "H", name: "Huelva" },
                { id: 6496702202020, code: "HU", name: "Huesca" },
                { id: 6496702234788, code: "J", name: "Jaén" },
                { id: 6496702267556, code: "LO", name: "La Rioja" },
                { id: 6496702300324, code: "GC", name: "Las Palmas" },
                { id: 6496702333092, code: "LE", name: "León" },
                { id: 6496702365860, code: "L", name: "Lleida" },
                { id: 6496702398628, code: "LU", name: "Lugo" },
                { id: 6496702431396, code: "M", name: "Madrid" },
                { id: 6496702464164, code: "MA", name: "Málaga" },
                { id: 6496702496932, code: "ML", name: "Melilla" },
                { id: 6496702529700, code: "MU", name: "Murcia" },
                { id: 6496702562468, code: "NA", name: "Navarra" },
                { id: 6496702595236, code: "OR", name: "Ourense" },
                { id: 6496702628004, code: "P", name: "Palencia" },
                { id: 6496702660772, code: "PO", name: "Pontevedra" },
                { id: 6496702693540, code: "SA", name: "Salamanca" },
                { id: 6496702726308, code: "TF", name: "Santa Cruz de Tenerife" },
                { id: 6496702759076, code: "SG", name: "Segovia" },
                { id: 6496702791844, code: "SE", name: "Sevilla" },
                { id: 6496702824612, code: "SO", name: "Soria" },
                { id: 6496702857380, code: "T", name: "Tarragona" },
                { id: 6496702890148, code: "TE", name: "Teruel" },
                { id: 6496702922916, code: "TO", name: "Toledo" },
                { id: 6496702955684, code: "V", name: "Valencia" },
                { id: 6496702988452, code: "VA", name: "Valladolid" },
                { id: 6496703021220, code: "BI", name: "Vizcaya" },
                { id: 6496703053988, code: "ZA", name: "Zamora" },
                { id: 6496703086756, code: "Z", name: "Zaragoza" }
            ]
        },
        {
            id: 1153688633508,
            code: "LK",
            name: "Sri Lanka",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/lk-B4kmUCxlnvSO.svg",
            currencyCode: "LKR",
            phoneCode: 94,
            provinces: []
        },
        {
            id: 1153691156644,
            code: "VC",
            name: "St. Vincent & Grenadines",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/vc-Df4zUfLTM_yn.svg",
            currencyCode: "XCD",
            phoneCode: 1784,
            provinces: []
        },
        {
            id: 1153687322788,
            code: "SD",
            name: "Sudan",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/sd-D0bnztWhu3YE.svg",
            currencyCode: "",
            phoneCode: 249,
            provinces: []
        },
        {
            id: 1153692303524,
            code: "SR",
            name: "Suriname",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/sr-Bumzb0EnIkXm.svg",
            currencyCode: "SRD",
            phoneCode: 597,
            provinces: []
        },
        {
            id: 1153689976996,
            code: "SJ",
            name: "Svalbard & Jan Mayen",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/sj-DSDNubTcH5f6.svg",
            currencyCode: "NOK",
            phoneCode: 47,
            provinces: []
        },
        {
            id: 626906366116,
            code: "SE",
            name: "Sweden",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/se-DmscRB-FJTvf.svg",
            currencyCode: "SEK",
            phoneCode: 46,
            provinces: []
        },
        {
            id: 626905710756,
            code: "CH",
            name: "Switzerland",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ch-BZzdDlUsZzKh.svg",
            currencyCode: "CHF",
            phoneCode: 41,
            provinces: []
        },
        {
            id: 1153688666276,
            code: "TW",
            name: "Taiwan",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/tw-DXv_yiAEx0Fa.svg",
            currencyCode: "TWD",
            phoneCode: 886,
            provinces: []
        },
        {
            id: 1153688699044,
            code: "TJ",
            name: "Tajikistan",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/tj-CVAysDii49JK.svg",
            currencyCode: "TJS",
            phoneCode: 992,
            provinces: []
        },
        {
            id: 1153687355556,
            code: "TZ",
            name: "Tanzania, United Republic Of",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/tz--TDymEHvG3hf.svg",
            currencyCode: "TZS",
            phoneCode: 255,
            provinces: []
        },
        {
            id: 1153688731812,
            code: "TH",
            name: "Thailand",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/th-QrJN3bvwt57Y.svg",
            currencyCode: "THB",
            phoneCode: 66,
            provinces: [
                { id: 12648675868836, code: "TH-37", name: "Amnat Charoen" },
                { id: 12648675901604, code: "TH-15", name: "Ang Thong" },
                { id: 12648675934372, code: "TH-10", name: "Bangkok" },
                { id: 12648675967140, code: "TH-38", name: "Bueng Kan" },
                { id: 12648675999908, code: "TH-31", name: "Buriram" },
                { id: 12648676032676, code: "TH-24", name: "Chachoengsao" },
                { id: 12648676065444, code: "TH-18", name: "Chai Nat" },
                { id: 12648676098212, code: "TH-36", name: "Chaiyaphum" },
                { id: 12648676130980, code: "TH-22", name: "Chanthaburi" },
                { id: 12648676163748, code: "TH-50", name: "Chiang Mai" },
                { id: 12648676196516, code: "TH-57", name: "Chiang Rai" },
                { id: 12648676229284, code: "TH-20", name: "Chon Buri" },
                { id: 12648676262052, code: "TH-86", name: "Chumphon" },
                { id: 12648676294820, code: "TH-46", name: "Kalasin" },
                { id: 12648676327588, code: "TH-62", name: "Kamphaeng Phet" },
                { id: 12648676360356, code: "TH-71", name: "Kanchanaburi" },
                { id: 12648676393124, code: "TH-40", name: "Khon Kaen" },
                { id: 12648676425892, code: "TH-81", name: "Krabi" },
                { id: 12648676458660, code: "TH-52", name: "Lampang" },
                { id: 12648676491428, code: "TH-51", name: "Lamphun" },
                { id: 12648676524196, code: "TH-42", name: "Loei" },
                { id: 12648676556964, code: "TH-16", name: "Lopburi" },
                { id: 12648676589732, code: "TH-58", name: "Mae Hong Son" },
                { id: 12648676622500, code: "TH-44", name: "Maha Sarakham" },
                { id: 12648676655268, code: "TH-49", name: "Mukdahan" },
                { id: 12648676688036, code: "TH-26", name: "Nakhon Nayok" },
                { id: 12648676720804, code: "TH-73", name: "Nakhon Pathom" },
                { id: 12648676753572, code: "TH-48", name: "Nakhon Phanom" },
                { id: 12648676786340, code: "TH-30", name: "Nakhon Ratchasima" },
                { id: 12648676819108, code: "TH-60", name: "Nakhon Sawan" },
                { id: 12648676851876, code: "TH-80", name: "Nakhon Si Thammarat" },
                { id: 12648676884644, code: "TH-55", name: "Nan" },
                { id: 12648676917412, code: "TH-96", name: "Narathiwat" },
                { id: 12648676950180, code: "TH-39", name: "Nong Bua Lam Phu" },
                { id: 12648676982948, code: "TH-43", name: "Nong Khai" },
                { id: 12648677015716, code: "TH-12", name: "Nonthaburi" },
                { id: 12648677048484, code: "TH-13", name: "Pathum Thani" },
                { id: 12648677081252, code: "TH-94", name: "Pattani" },
                { id: 12648677114020, code: "TH-S", name: "Pattaya" },
                { id: 12648677146788, code: "TH-82", name: "Phangnga" },
                { id: 12648677179556, code: "TH-93", name: "Phatthalung" },
                { id: 12648677212324, code: "TH-56", name: "Phayao" },
                { id: 12648677245092, code: "TH-67", name: "Phetchabun" },
                { id: 12648677277860, code: "TH-76", name: "Phetchaburi" },
                { id: 12648677310628, code: "TH-66", name: "Phichit" },
                { id: 12648677343396, code: "TH-65", name: "Phitsanulok" },
                { id: 12648677376164, code: "TH-14", name: "Phra Nakhon Si Ayutthaya" },
                { id: 12648677408932, code: "TH-54", name: "Phrae" },
                { id: 12648677441700, code: "TH-83", name: "Phuket" },
                { id: 12648677474468, code: "TH-25", name: "Prachin Buri" },
                { id: 12648677507236, code: "TH-77", name: "Prachuap Khiri Khan" },
                { id: 12648677540004, code: "TH-85", name: "Ranong" },
                { id: 12648677572772, code: "TH-70", name: "Ratchaburi" },
                { id: 12648677605540, code: "TH-21", name: "Rayong" },
                { id: 12648677638308, code: "TH-45", name: "Roi Et" },
                { id: 12648677671076, code: "TH-27", name: "Sa Kaeo" },
                { id: 12648677703844, code: "TH-47", name: "Sakon Nakhon" },
                { id: 12648677736612, code: "TH-11", name: "Samut Prakan" },
                { id: 12648677769380, code: "TH-74", name: "Samut Sakhon" },
                { id: 12648677802148, code: "TH-75", name: "Samut Songkhram" },
                { id: 12648677834916, code: "TH-19", name: "Saraburi" },
                { id: 12648677867684, code: "TH-91", name: "Satun" },
                { id: 12648677900452, code: "TH-17", name: "Sing Buri" },
                { id: 12648677933220, code: "TH-33", name: "Sisaket" },
                { id: 12648677965988, code: "TH-90", name: "Songkhla" },
                { id: 12648677998756, code: "TH-64", name: "Sukhothai" },
                { id: 12648678031524, code: "TH-72", name: "Suphan Buri" },
                { id: 12648678064292, code: "TH-84", name: "Surat Thani" },
                { id: 12648678097060, code: "TH-32", name: "Surin" },
                { id: 12648678129828, code: "TH-63", name: "Tak" },
                { id: 12648678162596, code: "TH-92", name: "Trang" },
                { id: 12648678195364, code: "TH-23", name: "Trat" },
                { id: 12648678228132, code: "TH-34", name: "Ubon Ratchathani" },
                { id: 12648678260900, code: "TH-41", name: "Udon Thani" },
                { id: 12648678293668, code: "TH-61", name: "Uthai Thani" },
                { id: 12648678326436, code: "TH-53", name: "Uttaradit" },
                { id: 12648678359204, code: "TH-95", name: "Yala" },
                { id: 12648678391972, code: "TH-35", name: "Yasothon" }
            ]
        },
        {
            id: 1153688764580,
            code: "TL",
            name: "Timor Leste",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/tl-CcIgU-3vCYff.svg",
            currencyCode: "USD",
            phoneCode: 670,
            provinces: []
        },
        {
            id: 1153687388324,
            code: "TG",
            name: "Togo",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/tg-BaW4W_OgKY-b.svg",
            currencyCode: "XOF",
            phoneCode: 228,
            provinces: []
        },
        {
            id: 1153691713700,
            code: "TK",
            name: "Tokelau",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/tk-CyLOtC5svrUz.svg",
            currencyCode: "NZD",
            phoneCode: 690,
            provinces: []
        },
        {
            id: 1153691746468,
            code: "TO",
            name: "Tonga",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/to-BzIVEtESTlz5.svg",
            currencyCode: "TOP",
            phoneCode: 676,
            provinces: []
        },
        {
            id: 1153691189412,
            code: "TT",
            name: "Trinidad & Tobago",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/tt-B9Hbp_cZ8daR.svg",
            currencyCode: "TTD",
            phoneCode: 1868,
            provinces: []
        },
        {
            id: 1153687421092,
            code: "TA",
            name: "Tristan da Cunha",
            flagUrl: "",
            currencyCode: "GBP",
            phoneCode: 2908,
            provinces: []
        },
        {
            id: 1153687453860,
            code: "TN",
            name: "Tunisia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/tn-Cfz5rGp-m4OA.svg",
            currencyCode: "",
            phoneCode: 216,
            provinces: []
        },
        {
            id: 1153688797348,
            code: "TR",
            name: "Türkiye",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/tr-4MQg98DqZUZJ.svg",
            currencyCode: "TRY",
            phoneCode: 90,
            provinces: []
        },
        {
            id: 1153688830116,
            code: "TM",
            name: "Turkmenistan",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/tm-Qd9z-Egt_zQj.svg",
            currencyCode: "",
            phoneCode: 993,
            provinces: []
        },
        {
            id: 1153691222180,
            code: "TC",
            name: "Turks & Caicos Islands",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/tc-DfShzjGjCh0_.svg",
            currencyCode: "USD",
            phoneCode: 1649,
            provinces: []
        },
        {
            id: 1153691779236,
            code: "TV",
            name: "Tuvalu",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/tv-Bz0AzNGq1rgg.svg",
            currencyCode: "AUD",
            phoneCode: 688,
            provinces: []
        },
        {
            id: 1153687486628,
            code: "UG",
            name: "Uganda",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ug-LmvsvPuDyUE0.svg",
            currencyCode: "UGX",
            phoneCode: 256,
            provinces: []
        },
        {
            id: 1153690009764,
            code: "UA",
            name: "Ukraine",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ua-DYYFmtT2mZMk.svg",
            currencyCode: "UAH",
            phoneCode: 380,
            provinces: []
        },
        {
            id: 626905546916,
            code: "AE",
            name: "United Arab Emirates",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ae-CSwq5reQPWt0.svg",
            currencyCode: "AED",
            phoneCode: 971,
            provinces: [
                { id: 6496700498084, code: "AZ", name: "Abu Dhabi" },
                { id: 6496700530852, code: "AJ", name: "Ajman" },
                { id: 6496700563620, code: "DU", name: "Dubai" },
                { id: 6496700596388, code: "FU", name: "Fujairah" },
                { id: 6496700629156, code: "RK", name: "Ras al-Khaimah" },
                { id: 6496700661924, code: "SH", name: "Sharjah" },
                { id: 6496700694692, code: "UQ", name: "Umm al-Quwain" }
            ]
        },
        {
            id: 626905940132,
            code: "GB",
            name: "United Kingdom",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/gb-CbvrkR0jozYb.svg",
            currencyCode: "GBP",
            phoneCode: 44,
            provinces: [
                { id: 6496703119524, code: "BFP", name: "British Forces" },
                { id: 6496703152292, code: "ENG", name: "England" },
                { id: 6496703185060, code: "NIR", name: "Northern Ireland" },
                { id: 6496703217828, code: "SCT", name: "Scotland" },
                { id: 6496703250596, code: "WLS", name: "Wales" }
            ]
        },
        {
            id: 626906431652,
            code: "US",
            name: "United States",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/us-YZEEIF9XYc5z.svg",
            currencyCode: "USD",
            phoneCode: 1,
            provinces: [
                { id: 6496711671972, code: "AL", name: "Alabama" },
                { id: 6496711704740, code: "AK", name: "Alaska" },
                { id: 6496711737508, code: "AS", name: "American Samoa" },
                { id: 6496711770276, code: "AZ", name: "Arizona" },
                { id: 6496711803044, code: "AR", name: "Arkansas" },
                { id: 6496713605284, code: "AA", name: "Armed Forces Americas" },
                { id: 6496713638052, code: "AE", name: "Armed Forces Europe" },
                { id: 6496713670820, code: "AP", name: "Armed Forces Pacific" },
                { id: 6496711835812, code: "CA", name: "California" },
                { id: 6496711868580, code: "CO", name: "Colorado" },
                { id: 6496711901348, code: "CT", name: "Connecticut" },
                { id: 6496711934116, code: "DE", name: "Delaware" },
                { id: 6496713441444, code: "DC", name: "District of Columbia" },
                { id: 6496711966884, code: "FM", name: "Federated States of Micronesia" },
                { id: 6496711999652, code: "FL", name: "Florida" },
                { id: 6496712032420, code: "GA", name: "Georgia" },
                { id: 6496712065188, code: "GU", name: "Guam" },
                { id: 6496712097956, code: "HI", name: "Hawaii" },
                { id: 6496712130724, code: "ID", name: "Idaho" },
                { id: 6496712163492, code: "IL", name: "Illinois" },
                { id: 6496712196260, code: "IN", name: "Indiana" },
                { id: 6496712229028, code: "IA", name: "Iowa" },
                { id: 6496712261796, code: "KS", name: "Kansas" },
                { id: 6496712294564, code: "KY", name: "Kentucky" },
                { id: 6496712327332, code: "LA", name: "Louisiana" },
                { id: 6496712360100, code: "ME", name: "Maine" },
                { id: 6496712392868, code: "MH", name: "Marshall Islands" },
                { id: 6496712425636, code: "MD", name: "Maryland" },
                { id: 6496712458404, code: "MA", name: "Massachusetts" },
                { id: 6496712491172, code: "MI", name: "Michigan" },
                { id: 6496712523940, code: "MN", name: "Minnesota" },
                { id: 6496712556708, code: "MS", name: "Mississippi" },
                { id: 6496712589476, code: "MO", name: "Missouri" },
                { id: 6496712622244, code: "MT", name: "Montana" },
                { id: 6496712655012, code: "NE", name: "Nebraska" },
                { id: 6496712687780, code: "NV", name: "Nevada" },
                { id: 6496712720548, code: "NH", name: "New Hampshire" },
                { id: 6496712753316, code: "NJ", name: "New Jersey" },
                { id: 6496712786084, code: "NM", name: "New Mexico" },
                { id: 6496712818852, code: "NY", name: "New York" },
                { id: 6496712851620, code: "NC", name: "North Carolina" },
                { id: 6496712884388, code: "ND", name: "North Dakota" },
                { id: 6496712917156, code: "MP", name: "Northern Mariana Islands" },
                { id: 6496712949924, code: "OH", name: "Ohio" },
                { id: 6496712982692, code: "OK", name: "Oklahoma" },
                { id: 6496713015460, code: "OR", name: "Oregon" },
                { id: 6496713048228, code: "PW", name: "Palau" },
                { id: 6496713080996, code: "PA", name: "Pennsylvania" },
                { id: 6496713113764, code: "PR", name: "Puerto Rico" },
                { id: 6496713146532, code: "RI", name: "Rhode Island" },
                { id: 6496713179300, code: "SC", name: "South Carolina" },
                { id: 6496713212068, code: "SD", name: "South Dakota" },
                { id: 6496713244836, code: "TN", name: "Tennessee" },
                { id: 6496713277604, code: "TX", name: "Texas" },
                { id: 6496713310372, code: "UT", name: "Utah" },
                { id: 6496713343140, code: "VT", name: "Vermont" },
                { id: 6496713572516, code: "VI", name: "Virgin Islands" },
                { id: 6496713375908, code: "VA", name: "Virginia" },
                { id: 6496713408676, code: "WA", name: "Washington" },
                { id: 6496713474212, code: "WV", name: "West Virginia" },
                { id: 6496713506980, code: "WI", name: "Wisconsin" },
                { id: 6496713539748, code: "WY", name: "Wyoming" }
            ]
        },
        {
            id: 1153691812004,
            code: "UM",
            name: "U.S. Outlying Islands",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/us-YZEEIF9XYc5z.svg",
            currencyCode: "USD",
            phoneCode: 268,
            provinces: []
        },
        {
            id: 1153692336292,
            code: "UY",
            name: "Uruguay",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/uy-JRXPAtnElX8J.svg",
            currencyCode: "UYU",
            phoneCode: 598,
            provinces: [
                { id: 12648689500324, code: "UY-AR", name: "Artigas" },
                { id: 12648689533092, code: "UY-CA", name: "Canelones" },
                { id: 12648689565860, code: "UY-CL", name: "Cerro Largo" },
                { id: 12648689598628, code: "UY-CO", name: "Colonia" },
                { id: 12648689631396, code: "UY-DU", name: "Durazno" },
                { id: 12648689664164, code: "UY-FS", name: "Flores" },
                { id: 12648689696932, code: "UY-FD", name: "Florida" },
                { id: 12648689729700, code: "UY-LA", name: "Lavalleja" },
                { id: 12648689762468, code: "UY-MA", name: "Maldonado" },
                { id: 12648689795236, code: "UY-MO", name: "Montevideo" },
                { id: 12648689828004, code: "UY-PA", name: "Paysandú" },
                { id: 12648689860772, code: "UY-RN", name: "Río Negro" },
                { id: 12648689893540, code: "UY-RV", name: "Rivera" },
                { id: 12648689926308, code: "UY-RO", name: "Rocha" },
                { id: 12648689959076, code: "UY-SA", name: "Salto" },
                { id: 12648689991844, code: "UY-SJ", name: "San José" },
                { id: 12648690024612, code: "UY-SO", name: "Soriano" },
                { id: 12648690057380, code: "UY-TA", name: "Tacuarembó" },
                { id: 12648690090148, code: "UY-TT", name: "Treinta y Tres" }
            ]
        },
        {
            id: 1153688862884,
            code: "UZ",
            name: "Uzbekistan",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/uz-TWV0iXMiWYV1.svg",
            currencyCode: "UZS",
            phoneCode: 998,
            provinces: []
        },
        {
            id: 1153691844772,
            code: "VU",
            name: "Vanuatu",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/vu-NsnrZXG3Az57.svg",
            currencyCode: "VUV",
            phoneCode: 678,
            provinces: []
        },
        {
            id: 1153692369060,
            code: "VE",
            name: "Venezuela",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ve-Bv1d4YAd7bdQ.svg",
            currencyCode: "USD",
            phoneCode: 58,
            provinces: [
                { id: 12648690122916, code: "VE-Z", name: "Amazonas" },
                { id: 12648690155684, code: "VE-B", name: "Anzoátegui" },
                { id: 12648690188452, code: "VE-C", name: "Apure" },
                { id: 12648690221220, code: "VE-D", name: "Aragua" },
                { id: 12648690253988, code: "VE-E", name: "Barinas" },
                { id: 12648690286756, code: "VE-F", name: "Bolívar" },
                { id: 12648690319524, code: "VE-G", name: "Carabobo" },
                { id: 12648690352292, code: "VE-H", name: "Cojedes" },
                { id: 12648690385060, code: "VE-Y", name: "Delta Amacuro" },
                { id: 12648690417828, code: "VE-W", name: "Dependencias Federales" },
                { id: 12648690450596, code: "VE-A", name: "Distrito Capital" },
                { id: 12648690483364, code: "VE-I", name: "Falcón" },
                { id: 12648690516132, code: "VE-J", name: "Guárico" },
                { id: 12648690548900, code: "VE-X", name: "La Guaira" },
                { id: 12648690581668, code: "VE-K", name: "Lara" },
                { id: 12648690614436, code: "VE-L", name: "Mérida" },
                { id: 12648690647204, code: "VE-M", name: "Miranda" },
                { id: 12648690679972, code: "VE-N", name: "Monagas" },
                { id: 12648690712740, code: "VE-O", name: "Nueva Esparta" },
                { id: 12648690745508, code: "VE-P", name: "Portuguesa" },
                { id: 12648690778276, code: "VE-R", name: "Sucre" },
                { id: 12648690811044, code: "VE-S", name: "Táchira" },
                { id: 12648690843812, code: "VE-T", name: "Trujillo" },
                { id: 12648690876580, code: "VE-U", name: "Yaracuy" },
                { id: 12648690909348, code: "VE-V", name: "Zulia" }
            ]
        },
        {
            id: 626905514148,
            code: "VN",
            name: "Vietnam",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/vn-DvVe8i2OgIZw.svg",
            currencyCode: "VND",
            phoneCode: 84,
            provinces: []
        },
        {
            id: 1153690304676,
            code: "VG",
            name: "Virgin Islands, British",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/vg-Disph98HnHmc.svg",
            currencyCode: "USD",
            phoneCode: 1284,
            provinces: []
        },
        {
            id: 1153691877540,
            code: "WF",
            name: "Wallis & Futuna",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/fr-CvJDduywicne.svg",
            currencyCode: "XPF",
            phoneCode: 681,
            provinces: []
        },
        {
            id: 1153687519396,
            code: "EH",
            name: "Western Sahara",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/eh-CgCBjspvMYlv.svg",
            currencyCode: "MAD",
            phoneCode: 2,
            provinces: []
        },
        {
            id: 1153688895652,
            code: "YE",
            name: "Yemen",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/ye-Banj2_lWpnLc.svg",
            currencyCode: "YER",
            phoneCode: 967,
            provinces: []
        },
        {
            id: 1153687552164,
            code: "ZM",
            name: "Zambia",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/zm-BU-XLGu_d0Iq.svg",
            currencyCode: "ZMW",
            phoneCode: 260,
            provinces: []
        },
        {
            id: 1153687584932,
            code: "ZW",
            name: "Zimbabwe",
            flagUrl: "https://cdn.shopify.com/shopifycloud/web/assets/v1/vite/client/en/assets/zw-DTkOjUDXJ4c_.svg",
            currencyCode: "USD",
            phoneCode: 263,
            provinces: []
        }
    ];

    const result = COUNTRIES.map((country) => {
        if(country.name === "Japan") return {
            ...country,
            name: COUNTRY_NAME_JP[country.code] || country.name,
            provinces: [
                { id: 6496707838116, code: 'JP-01', name: '北海道' },
                { id: 6496707870884, code: 'JP-02', name: '青森県' },
                { id: 6496707903652, code: 'JP-03', name: '岩手県' },
                { id: 6496707936420, code: 'JP-04', name: '宮城県' },
                { id: 6496707969188, code: 'JP-05', name: '秋田県' },
                { id: 6496708001956, code: 'JP-06', name: '山形県' },
                { id: 6496708034724, code: 'JP-07', name: '福島県' },
                { id: 6496708067492, code: 'JP-08', name: '茨城県' },
                { id: 6496708100260, code: 'JP-09', name: '栃木県' },
                { id: 6496708133028, code: 'JP-10', name: '群馬県' },
                { id: 6496708165796, code: 'JP-11', name: '埼玉県' },
                { id: 6496708198564, code: 'JP-12', name: '千葉県' },
                { id: 6496708231332, code: 'JP-13', name: '東京都' },
                { id: 6496708264100, code: 'JP-14', name: '神奈川県' },
                { id: 6496708296868, code: 'JP-15', name: '新潟県' },
                { id: 6496708329636, code: 'JP-16', name: '富山県' },
                { id: 6496708362404, code: 'JP-17', name: '石川県' },
                { id: 6496708395172, code: 'JP-18', name: '福井県' },
                { id: 6496708427940, code: 'JP-19', name: '山梨県' },
                { id: 6496708460708, code: 'JP-20', name: '長野県' },
                { id: 6496708493476, code: 'JP-21', name: '岐阜県' },
                { id: 6496708526244, code: 'JP-22', name: '静岡県' },
                { id: 6496708559012, code: 'JP-23', name: '愛知県' },
                { id: 6496708591780, code: 'JP-24', name: '三重県' },
                { id: 6496708624548, code: 'JP-25', name: '滋賀県' },
                { id: 6496708657316, code: 'JP-26', name: '京都府' },
                { id: 6496708690084, code: 'JP-27', name: '大阪府' },
                { id: 6496708722852, code: 'JP-28', name: '兵庫県' },
                { id: 6496708755620, code: 'JP-29', name: '奈良県' },
                { id: 6496708788388, code: 'JP-30', name: '和歌山県' },
                { id: 6496708821156, code: 'JP-31', name: '鳥取県' },
                { id: 6496708853924, code: 'JP-32', name: '島根県' },
                { id: 6496708886692, code: 'JP-33', name: '岡山県' },
                { id: 6496708919460, code: 'JP-34', name: '広島県' },
                { id: 6496708952228, code: 'JP-35', name: '山口県' },
                { id: 6496708984996, code: 'JP-36', name: '徳島県' },
                { id: 6496709017764, code: 'JP-37', name: '香川県' },
                { id: 6496709050532, code: 'JP-38', name: '愛媛県' },
                { id: 6496709083300, code: 'JP-39', name: '高知県' },
                { id: 6496709116068, code: 'JP-40', name: '福岡県' },
                { id: 6496709148836, code: 'JP-41', name: '佐賀県' },
                { id: 6496709181604, code: 'JP-42', name: '長崎県' },
                { id: 6496709214372, code: 'JP-43', name: '熊本県' },
                { id: 6496709247140, code: 'JP-44', name: '大分県' },
                { id: 6496709279908, code: 'JP-45', name: '宮崎県' },
                { id: 6496709312676, code: 'JP-46', name: '鹿児島県' },
                { id: 6496709345444, code: 'JP-47', name: '沖縄県' }
            ]
        }
        return {
            ...country,
            name: COUNTRY_NAME_JP[country.code] || country.name
        }
    });
  
    BSS_BCP_V2.customData.Countries = result;
}